import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { supabase } from "./supabaseClient"

const V = "#7C3AED"
const V_SOFT = "#F3F0FF"
const V_MID = "#EDE9FE"
const WHITE = "#FFFFFF"
const OFF = "#FAFAFA"
const TEXT = "#09090B"
const MUTED = "#71717A"
const BORDER = "#E4E4E7"
const SUCCESS = "#059669"
const SUCCESS_BG = "#ECFDF5"
const SUCCESS_MID = "#D1FAE5"
const WARN = "#D97706"
const WARN_BG = "#FFFBEB"
const H = "'Plus Jakarta Sans', system-ui, sans-serif"
const B = "'Manrope', system-ui, sans-serif"

const USER = {
  name: "María González",
  email: "maria@lunaestudio.com",
  plan: "starter",
  planLabel: { es:"Starter", en:"Starter" },
  projectSlots: 1,
  imgUsed: 24,
  imgTotal: 30,
  genUsedToday: 0,
  genLimitDay: 10,
  referralCode: "LUNA-MG47",
  referralCount: 3,
  referralCredit: 30,
  renewDate: { es:"15 de junio, 2025", en:"June 15, 2025" },
  joinDate: { es:"15 de enero, 2025", en:"January 15, 2025" },
}

const PROJECTS_DATA = [
  {
    id:"p1",
    nombre:{ es:"Luna Estudio", en:"Luna Studio" },
    tipo:{ es:"Marca personal", en:"Personal brand" },
    estilo:"Editorial",
    mercado:{ es:"Latinoamérica · CDMX", en:"Latin America · CDMX" },
    semana:{ es:"Semana 5", en:"Week 5" },
    enfoque:{ es:"Posicionamiento", en:"Positioning" },
    publicados:4, totalDias:7,
    imgUsed:6,
    voz:{ es:"Directa, cálida, sin tecnicismos", en:"Direct, warm, jargon-free" },
    personas:2,
    ultimaGen:{ es:"hace 2 días", en:"2 days ago" },
    active:true,
    characters:[
      { id:"c1", name:"Luna", style:"Animado 3D", desc:{ es:"Mujer joven, cabello negro liso, ojos café, piel morena clara, sonrisa amplia, ropa colorida", en:"Young woman, straight black hair, brown eyes, light brown skin, wide smile, colorful clothes" }, created:{ es:"hace 1 mes", en:"1 month ago" }, img:"editorial" },
    ],
    charSlots:1,
    charPacks:[
      { type:"pack3", used:0, total:3, expires:{ es:"15 de julio, 2025", en:"July 15, 2025" } }
    ],
  },
]

const TIPO_COLORS = {
  "Marca personal":{ bg:"#F3F0FF", color:V },
  "Personal brand":{ bg:"#F3F0FF", color:V },
  "E-commerce":{ bg:"#EFF6FF", color:"#2563EB" },
  "Servicio / Coach":{ bg:"#F0FDF4", color:SUCCESS },
  "Service / Coach":{ bg:"#F0FDF4", color:SUCCESS },
}

const STYLE_GRADIENTS = {
  Editorial:"linear-gradient(135deg,#F5F0E8,#E8DDD0)",
  "Animado 3D":"linear-gradient(135deg,#FFF0F8,#E8D5FF)",
  Lifestyle:"linear-gradient(135deg,#FFF8F0,#FFD9C0)",
  Bold:`linear-gradient(135deg,#3D1A6E,${V})`,
}

const CHAR_PACKS = {
  es:[
    { id:"single", name:"1 personaje", price:"$9", unit:"$9 c/u", expires:"Sin vencimiento", highlight:false },
    { id:"pack3",  name:"3 personajes", price:"$19", unit:"$6.33 c/u", expires:"Válido 6 meses", highlight:false },
    { id:"pack5",  name:"5 personajes", price:"$29", unit:"$5.80 c/u", expires:"Válido 6 meses", highlight:true },
  ],
  en:[
    { id:"single", name:"1 character", price:"$9", unit:"$9 each", expires:"No expiration", highlight:false },
    { id:"pack3",  name:"3 characters", price:"$19", unit:"$6.33 each", expires:"Valid 6 months", highlight:false },
    { id:"pack5",  name:"5 characters", price:"$29", unit:"$5.80 each", expires:"Valid 6 months", highlight:true },
  ],
}

const IMG_PACKS = {
  es:[
    { id:"mini", name:"Mini", imgs:"15 imágenes", price:"$9" },
    { id:"standard", name:"Standard", imgs:"40 imágenes", price:"$19" },
    { id:"pro", name:"Pro", imgs:"100 imágenes", price:"$39" },
  ],
  en:[
    { id:"mini", name:"Mini", imgs:"15 images", price:"$9" },
    { id:"standard", name:"Standard", imgs:"40 images", price:"$19" },
    { id:"pro", name:"Pro", imgs:"100 images", price:"$39" },
  ],
}

function CharacterMockup({ character, style="Editorial", small=false }) {
  const grad = STYLE_GRADIENTS[style] || STYLE_GRADIENTS.Editorial
  const isDark = style === "Bold"
  const h = small ? 72 : 120
  return (
    <div style={{ background:grad, borderRadius:small?8:12, height:h, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:small?"6px":"1rem", position:"relative", overflow:"hidden" }}>
      <div style={{ position:"absolute", inset:0, opacity:.08, backgroundImage:"radial-gradient(circle at 30% 70%,#fff 0%,transparent 50%)" }}/>
      <div style={{ fontSize:small?20:32, marginBottom:small?2:4 }}>
        {style==="Animado 3D"?"🎭":"👤"}
      </div>
      {!small && (
        <div style={{ fontFamily:H, fontSize:11, fontWeight:700, color:isDark?WHITE:TEXT, textAlign:"center", letterSpacing:"-.01em" }}>
          {character.name}
        </div>
      )}
      {style==="Animado 3D" && (
        <div style={{ position:"absolute", top:small?3:6, right:small?4:6, fontSize:8, fontWeight:700, color:V, background:"rgba(255,255,255,.85)", borderRadius:8, padding:"1px 5px", fontFamily:B }}>
          ⚡ 2 {small?"cr.":"créditos"}
        </div>
      )}
      <div style={{ position:"absolute", bottom:small?3:6, right:small?5:8, fontSize:8, color:isDark?"rgba(255,255,255,.5)":"rgba(0,0,0,.3)", fontFamily:B }}>{style}</div>
    </div>
  )
}

export default function KorivaDashboard() {
  const navigate = useNavigate()
  const [lang, setLang]       = useState("es")
  const [view, setView]       = useState("dashboard") // dashboard | profile | characters | upgrade | buy_chars | buy_imgs | create_char | adn
  const [adnProyecto, setAdnProyecto] = useState(null) // id del proyecto cuyo ADN se esta viendo
  const [adnDatos, setAdnDatos] = useState(null) // datos cargados del ADN (visibility, voz, personas)
  const [reanalisisProyecto, setReanalisisProyecto] = useState(null) // id del proyecto a re-analizar
  const [reanalisisPaso, setReanalisisPaso] = useState(1) // 1=pregunta, 2=textarea, 3=cargando, 4=resultado
  const [reanalisisNuevaBio, setReanalisisNuevaBio] = useState("")
  const [reanalisisResultado, setReanalisisResultado] = useState(null)
  const [reanalisisError, setReanalisisError] = useState(null)
  const [adnCargando, setAdnCargando] = useState(false)
  const [charForm, setCharForm] = useState({ nombre:"", que_es:"", personalidad:"", extra:"" })
  const [creandoChar, setCreandoChar] = useState(false)
  const [wellnessIdx, setWellnessIdx] = useState(0)
  const wellnessMsgs = {
    es: [
      "Respira profundo tres veces, suelta los hombros",
      "Mientras esperamos, estírate suavemente",
      "KORIVA está creando algo único para ti",
      "Tómate un sorbo de agua",
      "Cierra los ojos 10 segundos, descansa la vista",
      "Lo bueno toma su tiempo. Casi está"
    ],
    en: [
      "Take three deep breaths, drop your shoulders",
      "While we wait, stretch gently",
      "KORIVA is creating something unique for you",
      "Take a sip of water",
      "Close your eyes for 10 seconds, rest your view",
      "Good things take time. Almost there"
    ]
  }
  useEffect(() => {
    if (!creandoChar) { setWellnessIdx(0); return }
    const id = setInterval(() => setWellnessIdx(i => (i + 1) % wellnessMsgs.es.length), 5000)
    return () => clearInterval(id)
  }, [creandoChar])
  const [charCreado, setCharCreado] = useState(null)
  const [uploadCharForm, setUploadCharForm] = useState({ nombre:"", foto:null })
  const [subiendoChar, setSubiendoChar] = useState(false)

  async function recargarPersonajes() {
    try {
      const { data: chars } = await supabase
        .from("characters")
        .select("id, nombre, descripcion_fisica, imagen_url, created_at, origen, tipo")
        .eq("project_id", proj.id)
        .order("created_at", { ascending: false })
      const charsTraducidos = (chars || []).map(c => ({
        id: c.id,
        name: c.nombre,
        desc: { es: c.descripcion_fisica || "", en: c.descripcion_fisica || "" },
        imagen_url: c.imagen_url,
        origen: c.origen || "creado",
        tipo: c.tipo || "plan",
        style: "Animado 3D",
        created: {
          es: c.created_at ? new Date(c.created_at).toLocaleDateString("es-ES",{day:"numeric",month:"short"}) : "",
          en: c.created_at ? new Date(c.created_at).toLocaleDateString("en-US",{day:"numeric",month:"short"}) : ""
        }
      }))
      setProjects(prev => prev.map(p => p.id === proj.id ? { ...p, characters: charsTraducidos } : p))
    } catch (e) {
      console.error("Error recargando personajes:", e)
    }
  }

  async function subirPersonaje() {
    if (!uploadCharForm.nombre || !uploadCharForm.foto) return
    setSubiendoChar(true)
    setCharCreado(null)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(process.env.REACT_APP_API_URL + "/api/upload-character", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${session?.access_token}`
        },
        body: JSON.stringify({
          project_id: proj.id,
          nombre: uploadCharForm.nombre,
          photo_base64: uploadCharForm.foto
        })
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || "Error al subir personaje")
      setCharCreado(data.character)
      await recargarPersonajes()
    } catch (e) {
      alert((lang==="es"?"Error al subir el personaje: ":"Error uploading character: ") + e.message)
    } finally {
      setSubiendoChar(false)
    }
  }

  async function crearPersonaje() {
    if (!charForm.nombre || !charForm.que_es || !charForm.personalidad) return
    setCreandoChar(true)
    setCharCreado(null)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(process.env.REACT_APP_API_URL + "/api/generate-character", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${session?.access_token}`
        },
        body: JSON.stringify({
          project_id: proj.id,
          nombre: charForm.nombre,
          que_es: charForm.que_es,
          personalidad: charForm.personalidad,
          extra: charForm.extra
        })
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || "Error al crear personaje")
      setCharCreado(data.character)
      await recargarPersonajes()
    } catch (e) {
      alert((lang==="es"?"Error al crear el personaje: ":"Error creating character: ") + e.message)
    } finally {
      setCreandoChar(false)
    }
  }
  const [activeProject, setActiveProject] = useState("p1")
  const [cargando, setCargando] = useState(true)
  const [projects, setProjects] = useState([])
  const [user, setUser] = useState(USER)

  useEffect(() => {
    const loadDashboard = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) return
      const { data: u } = await supabase
        .from("users")
        .select("nombre, email, plan, lang, img_credits_total, img_credits_used, img_credits_extra, char_credits_extra, last_renewal_date, last_dna_reanalysis, created_at")
        .eq("id", session.user.id)
        .single()
      if (u) {
        if (u.lang) setLang(u.lang)
        const planLabels = { starter:"Starter", growth:"Growth", agency:"Agency" }
        setUser(prev => ({
          ...prev,
          name: u.nombre || prev.name,
          email: u.email || prev.email,
          plan: u.plan || prev.plan,
          planLabel: { es: planLabels[u.plan] || "Starter", en: planLabels[u.plan] || "Starter" },
          imgTotal: (u.img_credits_total || 0) + (u.img_credits_extra || 0),
          imgUsed: u.img_credits_used || 0,
          charCreditsExtra: u.char_credits_extra || 0,
          lastRenewalDate: u.last_renewal_date || u.created_at,
          lastDnaReanalysis: u.last_dna_reanalysis || null,
          joinDate: u.created_at ? {
            es: new Date(u.created_at).toLocaleDateString("es-ES", { day:"numeric", month:"long", year:"numeric" }),
            en: new Date(u.created_at).toLocaleDateString("en-US", { day:"numeric", month:"long", year:"numeric" })
          } : prev.joinDate,
          renewDate: { es: "Por definir", en: "To be defined" }
        }))
      }

      // Cargar TODOS los proyectos del usuario
      const { data: todosProyectos } = await supabase
        .from("projects")
        .select("id, nombre, tipo_negocio, estilo_imagen, activo, brand_forms(id)")
        .eq("user_id", session.user.id)
        .order("created_at", { ascending: true })

      const hayMarca = (todosProyectos || []).some(p => p.brand_forms && (Array.isArray(p.brand_forms) ? p.brand_forms.length > 0 : true))

      if (hayMarca) {
        // Armar cada proyecto con sus datos relacionados
        const proyectosArmados = await Promise.all(todosProyectos.map(async (pr) => {
          const [weeksRes, voiceRes, personasRes, formRes] = await Promise.all([
            supabase.from("weeks").select("enfoque, created_at").eq("project_id", pr.id).order("created_at", { ascending: false }),
            supabase.from("brand_voice").select("tono").eq("project_id", pr.id).maybeSingle(),
            supabase.from("buyer_personas").select("id").eq("project_id", pr.id),
            supabase.from("brand_forms").select("pais, ciudad").eq("project_id", pr.id).maybeSingle()
          ])
          const weeksArr = weeksRes.data || []
          const numWeeks = weeksArr.length
          const ultimoEnfoque = numWeeks > 0 ? (weeksArr[0].enfoque || "") : ""
          const tono = voiceRes.data ? (voiceRes.data.tono || "") : ""
          const numPersonas = (personasRes.data || []).length
          const pais = formRes.data ? (formRes.data.pais || "") : ""
          const ciudad = formRes.data ? (formRes.data.ciudad || "") : ""
          const mercadoTxt = [pais, ciudad].filter(Boolean).join(" \u00b7 ")
          return {
            id: pr.id,
            nombre: { es: pr.nombre || "", en: pr.nombre || "" },
            tipo: { es: pr.tipo_negocio || "", en: pr.tipo_negocio || "" },
            estilo: pr.estilo_imagen || "",
            mercado: { es: mercadoTxt, en: mercadoTxt },
            semana: { es: "Semana " + numWeeks, en: "Week " + numWeeks },
            enfoque: { es: ultimoEnfoque, en: ultimoEnfoque },
            publicados: 0, totalDias: 7,
            voz: { es: tono, en: tono },
            personas: numPersonas,
            ultimaGen: { es: "\u2014", en: "\u2014" },
            active: !!pr.activo,
            charSlots: 1,
            charPacks: [],
            characters: []
          }
        }))
        setProjects(proyectosArmados)

        // Marcar el proyecto activo
        const activo = todosProyectos.find(p => p.activo) || todosProyectos[0]
        setActiveProject(activo.id)

        // Cargar personajes SOLO del proyecto activo (no sobrecargar)
        const { data: chars } = await supabase
          .from("characters")
          .select("id, nombre, descripcion_fisica, imagen_url, created_at, origen, tipo")
          .eq("project_id", activo.id)
          .order("created_at", { ascending: false })
        if (chars && chars.length > 0) {
          const charsTraducidos = chars.map(c => ({
            id: c.id,
            name: c.nombre,
            desc: { es: c.descripcion_fisica || "", en: c.descripcion_fisica || "" },
            imagen_url: c.imagen_url,
            origen: c.origen || "creado",
            tipo: c.tipo || "plan",
            style: "Animado 3D",
            created: {
              es: c.created_at ? new Date(c.created_at).toLocaleDateString("es-ES",{day:"numeric",month:"short"}) : "",
              en: c.created_at ? new Date(c.created_at).toLocaleDateString("en-US",{day:"numeric",month:"short"}) : ""
            }
          }))
          setProjects(prev => prev.map(p => p.id === activo.id ? { ...p, characters: charsTraducidos } : p))
        }
        setCargando(false)
      } else {
        setCargando(false)
        navigate('/bienvenida')
        return
      }
    }
    loadDashboard()
  }, [])

  // Cargar el ADN del proyecto seleccionado (solo lectura)
  useEffect(() => {
    if (!adnProyecto) { setAdnDatos(null); return }
    let cancelado = false
    async function cargarADN() {
      setAdnCargando(true)
      const [visRes, vozRes, personasRes] = await Promise.all([
        supabase.from("ai_visibility").select("score, lo_claro, lo_borroso, sugerencias, created_at").eq("project_id", adnProyecto).order("created_at",{ascending:false}).limit(1).maybeSingle(),
        supabase.from("brand_voice").select("tono, estilo, evitar, ejemplo").eq("project_id", adnProyecto).maybeSingle(),
        supabase.from("buyer_personas").select("nombre, edad, ocupacion, ubicacion, descripcion, necesidad, que_valora, como_decide, objecion").eq("project_id", adnProyecto)
      ])
      if (cancelado) return
      setAdnDatos({
        visibility: visRes.data || null,
        voz: vozRes.data || null,
        personas: personasRes.data || []
      })
      setAdnCargando(false)
    }
    cargarADN()
    return () => { cancelado = true }
  }, [adnProyecto])
  const [showLimitMsg, setShowLimitMsg] = useState(false)
  const [copiedRef, setCopiedRef] = useState(false)
  const [selectedPack, setSelectedPack] = useState(null)
  const [showPassChange, setShowPassChange] = useState(false)
  const [newPass, setNewPass] = useState("")
  const [newPass2, setNewPass2] = useState("")
  const [passMsg, setPassMsg] = useState(null)
  const [savingPass, setSavingPass] = useState(false)
  async function cambiarContrasena() {
    setPassMsg(null)
    if (newPass.length < 6) { setPassMsg({ tipo:"error", txt: es?"La contraseña debe tener al menos 6 caracteres.":"Password must be at least 6 characters." }); return }
    if (newPass !== newPass2) { setPassMsg({ tipo:"error", txt: es?"Las contraseñas no coinciden.":"Passwords do not match." }); return }
    setSavingPass(true)
    const { error } = await supabase.auth.updateUser({ password: newPass })
    setSavingPass(false)
    if (error) { setPassMsg({ tipo:"error", txt: es?"No se pudo cambiar la contraseña. Intenta de nuevo.":"Could not change password. Try again." }) }
    else {
      setPassMsg({ tipo:"ok", txt: es?"Contraseña actualizada con éxito.":"Password updated successfully." })
      setNewPass(""); setNewPass2(""); setShowPassChange(false)
    }
  }
  const [buyingPack, setBuyingPack] = useState(false)
  const [buyError, setBuyError] = useState(null)
  const [selectedCharPack, setSelectedCharPack] = useState(null)
  const [buyingCharPack, setBuyingCharPack] = useState(false)
  const [buyCharError, setBuyCharError] = useState(null)

  async function abrirProyecto(projectId, destino) {
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) { window.location.href = "/login"; return }
      // Marcar este proyecto como activo y desactivar los demas
      await supabase.from("projects").update({ activo: false }).eq("user_id", session.user.id)
      await supabase.from("projects").update({ activo: true }).eq("id", projectId)
      window.location.href = destino
    } catch (e) {
      alert(lang==="es" ? "No se pudo abrir el proyecto" : "Could not open project")
    }
  }

  async function upgradePlan(targetPlan) {
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(process.env.REACT_APP_API_URL + "/api/create-checkout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${session?.access_token}`
        },
        body: JSON.stringify({ plan: targetPlan })
      })
      const data = await res.json()
      if (!res.ok || !data.url) {
        alert(lang==="es" ? "No se pudo iniciar el cambio de plan" : "Could not start plan change")
        return
      }
      window.location.href = data.url
    } catch (e) {
      alert(lang==="es" ? "No se pudo conectar con el servidor" : "Could not connect to server")
    }
  }

  async function cancelarSuscripcion() {
    const confirmar = window.confirm(
      lang==="es"
        ? "Si cancelas, tu acceso terminara al final del periodo ya pagado y no se renovara. Tus datos quedan guardados. Puedes reactivar despues. ¿Continuar?"
        : "If you cancel, your access will end at the end of the paid period and will not renew. Your data stays saved. You can reactivate later. Continue?"
    )
    if (!confirmar) return
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(process.env.REACT_APP_API_URL + "/api/cancel-subscription", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${session?.access_token}`
        }
      })
      const data = await res.json()
      if (!res.ok) {
        alert(lang==="es" ? ("No se pudo cancelar: " + (data.error || "")) : ("Could not cancel: " + (data.error || "")))
        return
      }
      alert(lang==="es"
        ? "Tu suscripcion fue cancelada. Tendras acceso hasta el final del periodo pagado."
        : "Your subscription was cancelled. You will have access until the end of the paid period.")
      window.location.reload()
    } catch (e) {
      alert(lang==="es" ? "No se pudo conectar con el servidor" : "Could not connect to server")
    }
  }

  async function buyPack() {
    if (!selectedPack) { setBuyError("Elige un paquete primero"); return }
    setBuyError(null)
    setBuyingPack(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(process.env.REACT_APP_API_URL + "/api/create-pack-checkout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${session?.access_token}`
        },
        body: JSON.stringify({ pack: selectedPack })
      })
      const data = await res.json()
      if (!res.ok || !data.url) {
        setBuyError(data.error || "No se pudo iniciar la compra")
        setBuyingPack(false)
        return
      }
      window.location.href = data.url
    } catch (e) {
      setBuyError("No se pudo conectar con el servidor")
      setBuyingPack(false)
    }
  }

  async function buyCharPack() {
    if (!selectedCharPack) { setBuyCharError("Elige un paquete primero"); return }
    setBuyCharError(null)
    setBuyingCharPack(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(process.env.REACT_APP_API_URL + "/api/create-char-pack-checkout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${session?.access_token}`
        },
        body: JSON.stringify({ pack: selectedCharPack })
      })
      const data = await res.json()
      if (!res.ok || !data.url) {
        setBuyCharError(data.error || "No se pudo iniciar la compra")
        setBuyingCharPack(false)
        return
      }
      window.location.href = data.url
    } catch (e) {
      setBuyCharError("No se pudo conectar con el servidor")
      setBuyingCharPack(false)
    }
  }

  const es = lang === "es"
  const proj = projects.find(p=>p.id===activeProject) || projects[0]
  const imgPct = (user.imgUsed/user.imgTotal)*100
  const imgLow = imgPct >= 80
  const genPct = (user.genUsedToday/user.genLimitDay)*100
  const genLow = genPct >= 80
  const charPacks = CHAR_PACKS[lang]
  const imgPacks  = IMG_PACKS[lang]

  const charSlotsPorPlan = user.plan==="agency" ? 40 : user.plan==="growth" ? 10 : 1
  const totalCharsAvailable = charSlotsPorPlan
    + (proj?.charPacks || []).reduce((sum,p)=>sum+(p.total-p.used),0)
  const charsUsed = (proj?.characters || []).filter(c => (c.origen || "creado") === "creado").length
  // charsPlanUsados se carga via useEffect mas abajo (query directa a Supabase)
  const [charsPlanUsados, setCharsPlanUsados] = useState(0)
  useEffect(() => {
    async function contarCharsPlan() {
      if (!user.lastRenewalDate) return
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) return
      const { data: projs } = await supabase
        .from("projects")
        .select("id")
        .eq("user_id", session.user.id)
      const projectIds = (projs || []).map(p => p.id)
      if (projectIds.length === 0) { setCharsPlanUsados(0); return }
      const { count } = await supabase
        .from("characters")
        .select("*", { count: "exact", head: true })
        .in("project_id", projectIds)
        .eq("tipo", "plan")
        .gte("created_at", user.lastRenewalDate)
      setCharsPlanUsados(count || 0)
    }
    contarCharsPlan()
  }, [user.lastRenewalDate, proj?.characters?.length])
  if (cargando) return <div style={{ minHeight:"100vh", background:"#FFFFFF" }} />
  const charsCreadosUsuario = charsPlanUsados

  function copyRef() {
    navigator.clipboard.writeText(`https://app.korivalab.com?ref=${user.referralCode}`).catch(()=>{})
    setCopiedRef(true); setTimeout(()=>setCopiedRef(false),2200)
  }

  const NAV = {
    es:[ {id:"dashboard",label:"Proyectos",icon:"⊞"}, {id:"adn",label:"ADN de proyectos",icon:"🧬"}, {id:"characters",label:"Personajes",icon:"🎭"}, {id:"profile",label:"Mi perfil",icon:"⊙"}, {id:"logout",label:"Cerrar sesión",icon:"↪"} ],
    en:[ {id:"dashboard",label:"Projects",icon:"⊞"}, {id:"adn",label:"Brand DNA",icon:"🧬"}, {id:"characters",label:"Characters",icon:"🎭"}, {id:"profile",label:"My profile",icon:"⊙"}, {id:"logout",label:"Sign out",icon:"↪"} ],
  }

  const T = {
    es:{
      greeting:"Hola de nuevo",
      newProject:"+ Nuevo proyecto",
      projectsTitle:"Mis proyectos",
      projectsSub:"Selecciona un proyecto para trabajar.",
      weekLabel:"Semana", focusLabel:"Enfoque", styleLabel:"Estilo", marketLabel:"Mercado",
      personasLabel:"Buyer personas", voiceLabel:"Voz de marca", lastGenLabel:"Última generación",
      publishedLabel:"Publicados", of:"de", days:"días",
      openProject:"Abrir proyecto →", generateWeek:"Generar semana →", editMarca:"Editar marca →", verMetricas:"Ver métricas →",
      lockedTitle:"Slot disponible con Growth",
      lockedSub:"Tu plan Starter incluye 1 proyecto. Sube a Growth para gestionar hasta 5.",
      lockedCta:"Subir a Growth — $87/mes →",
      imgTitle:"Imágenes este mes",
      genTitle:"Generaciones de hoy",
      genLimit:"Llegaste al límite de hoy.",
      genLimitNote:"Puedes generar de nuevo mañana a las 12:00 AM. Mientras tanto puedes revisar tu archivo semanal o tu tracker de crecimiento.",
      genLimitClose:"Entendido",
      imgAdd:"Comprar más →",
      upgrade:"Mejorar plan",
      upgradeBanner:"¿Tu negocio está creciendo? Tu plan también puede.",
      upgradeBannerSub:"Más proyectos, más imágenes, más personajes.",
      upgradeBannerBtn:"Ver opciones →",
      // CHARACTERS
      charsTitle:"Personajes de",
      charsSub:"Crea personajes una vez. KORIVA los recuerda y los usa en cualquier campaña.",
      charSlotLabel:"Disponibles en este proyecto",
      charNew:"+ Crear personaje",
      charBuy:"Comprar personajes →",
      charUsed:"Creados",
      charAvail:"Disponibles",
      charExpires:"Vence",
      charPack:"Paquete activo",
      charNone:"Ningún personaje creado aún.",
      charNoneNote:"Crea tu primer personaje y úsalo en todas tus campañas semanales.",
      charBuyTitle:"Agregar personajes",
      charBuyNote:"Los personajes se asignan a este proyecto. Los paquetes vencen en 6 meses.",
      charBestValue:"Mejor valor",
      charBuyBtn:"Comprar →",
      charBuyClose:"Cancelar",
      // PROFILE
      profileTitle:"Mi perfil",
      planSection:"Mi plan",
      planActive:"Plan activo",
      planRenew:"Próxima renovación",
      planJoin:"Miembro desde",
      planChange:"Cambiar plan →",
      planCancel:"Cancelar suscripción",
      cancelNote:"Al cancelar, tu cuenta y proyectos se mantienen hasta el final del ciclo pagado.",
      notifSection:"Recordatorios",
      notif1:"Aviso 7 días antes de renovación",
      notif2:"Aviso 1 día antes de renovación",
      notif3:"Alerta cuando quedan pocas imágenes",
      notif4:"Recordatorio semanal de generación",
      referralSection:"Comparte y gana",
      referralDesc:"Cuando alguien se suscribe con tu enlace y completa su primer mes, tú y ellos reciben $10 de crédito automático.",
      referralLink:"Tu enlace personal",
      referralCopy:"Copiar enlace",
      referralCopied:"¡Copiado!",
      referralStats:"Referidos activos",
      referralCredit:"Crédito acumulado",
      referralNote:"Disponible durante los primeros 6 meses del lanzamiento.",
      imgSection:"Imágenes este mes",
      imgBuyMore:"Comprar paquete →",
      passSection:"Seguridad",
      passChange:"Cambiar contraseña →",
      dangerSection:"Zona de precaución",
      deleteAccount:"Eliminar cuenta",
      deleteNote:"Al eliminar tu cuenta se borran todos tus proyectos, personajes e historial de contenido. Esta acción no se puede deshacer.",
    },
    en:{
      greeting:"Welcome back",
      newProject:"+ New project",
      projectsTitle:"My projects",
      projectsSub:"Select a project to work on it.",
      weekLabel:"Week", focusLabel:"Focus", styleLabel:"Style", marketLabel:"Market",
      personasLabel:"Buyer personas", voiceLabel:"Brand voice", lastGenLabel:"Last generation",
      publishedLabel:"Published", of:"of", days:"days",
      openProject:"Open project →", generateWeek:"Generate week →", editMarca:"Edit brand →", verMetricas:"View metrics →",
      lockedTitle:"Slot available with Growth",
      lockedSub:"Your Starter plan includes 1 project. Upgrade to Growth to manage up to 5.",
      lockedCta:"Upgrade to Growth — $87/mo →",
      imgTitle:"Images this month",
      genTitle:"Generations today",
      genLimit:"You reached today's limit.",
      genLimitNote:"You can generate again tomorrow at 12:00 AM. Meanwhile you can review your weekly archive or growth tracker.",
      genLimitClose:"Got it",
      imgAdd:"Buy more →",
      upgrade:"Upgrade plan",
      upgradeBanner:"Is your business growing? Your plan can too.",
      upgradeBannerSub:"More projects, more images, more characters.",
      upgradeBannerBtn:"See options →",
      charsTitle:"Characters of",
      charsSub:"Create characters once. KORIVA remembers them and uses them in any campaign.",
      charSlotLabel:"Available in this project",
      charNew:"+ Create character",
      charBuy:"Buy characters →",
      charUsed:"Created",
      charAvail:"Available",
      charExpires:"Expires",
      charPack:"Active pack",
      charNone:"No characters created yet.",
      charNoneNote:"Create your first character and use it in all your weekly campaigns.",
      charBuyTitle:"Add characters",
      charBuyNote:"Characters are assigned to this project. Packs expire in 6 months.",
      charBestValue:"Best value",
      charBuyBtn:"Buy →",
      charBuyClose:"Cancel",
      profileTitle:"My profile",
      planSection:"My plan",
      planActive:"Active plan",
      planRenew:"Next renewal",
      planJoin:"Member since",
      planChange:"Change plan →",
      planCancel:"Cancel subscription",
      cancelNote:"When you cancel, your account and projects remain active until the end of the paid cycle.",
      notifSection:"Reminders",
      notif1:"Notice 7 days before renewal",
      notif2:"Notice 1 day before renewal",
      notif3:"Alert when images are running low",
      notif4:"Weekly generation reminder",
      referralSection:"Share and earn",
      referralDesc:"When someone subscribes through your link and completes their first month, both of you get $10 credit automatically.",
      referralLink:"Your personal link",
      referralCopy:"Copy link",
      referralCopied:"Copied!",
      referralStats:"Active referrals",
      referralCredit:"Accumulated credit",
      referralNote:"Available during the first 6 months after launch.",
      imgSection:"Images this month",
      imgBuyMore:"Buy pack →",
      passSection:"Security",
      passChange:"Change password →",
      dangerSection:"Caution zone",
      deleteAccount:"Delete account",
      deleteNote:"Deleting your account removes all your projects, characters and content history. This action cannot be undone.",
    },
  }
  const t = T[lang]
  const nav = NAV[lang]

  const s = {
    page:    { minHeight:"100vh", background:WHITE, fontFamily:B, color:TEXT, display:"grid", gridTemplateColumns:"220px 1fr" },
    sidebar: { borderRight:`1px solid ${BORDER}`, display:"flex", flexDirection:"column", background:OFF, minHeight:"100vh", position:"sticky", top:0, height:"100vh", overflowY:"auto" },
    sideTop: { padding:"1.25rem 1rem 1rem", borderBottom:`1px solid ${BORDER}` },
    logo:    { fontFamily:H, fontSize:15, fontWeight:800, color:TEXT, letterSpacing:"-.02em", marginBottom:"1rem" },
    logoV:   { color:V },
    userCard:{ background:WHITE, border:`1px solid ${BORDER}`, borderRadius:9, padding:".65rem .85rem", marginBottom:".75rem" },
    userName:{ fontFamily:H, fontSize:12, fontWeight:700, color:TEXT, marginBottom:2 },
    planRow: { display:"flex", alignItems:"center", justifyContent:"space-between" },
    planBadge:{ fontSize:9, fontWeight:700, color:V, background:V_SOFT, border:`1px solid ${V_MID}`, borderRadius:8, padding:"2px 7px", fontFamily:B },
    upgradeLink:{ fontSize:9, color:MUTED, cursor:"pointer", fontFamily:B, textDecoration:"underline", background:"none", border:"none" },
    navWrap: { padding:".75rem .75rem", flex:1 },
    navItem: (a) => ({ display:"flex", alignItems:"center", gap:7, padding:".55rem .7rem", borderRadius:8, marginBottom:2, cursor:"pointer", background:a?V_SOFT:"transparent", border:a?`1px solid ${V_MID}`:"1px solid transparent", transition:"all .18s" }),
    navIcon: (a) => ({ fontSize:13, color:a?V:MUTED, width:16, textAlign:"center", flexShrink:0 }),
    navLabel:(a) => ({ fontSize:14, fontWeight:a?700:500, color:a?V:MUTED, letterSpacing:"-.01em" }),
    sideBottom:{ padding:".85rem 1rem", borderTop:`1px solid ${BORDER}` },
    meterRow:{ marginBottom:8 },
    meterTop:{ display:"flex", justifyContent:"space-between", marginBottom:5, alignItems:"center" },
    meterLbl:{ fontSize:11, color:MUTED, fontFamily:B },
    meterNum:(low)=>({ fontSize:12, fontWeight:700, color:low?WARN:TEXT, fontFamily:B }),
    meterBar:{ height:5, background:BORDER, borderRadius:3, overflow:"hidden" },
    meterFill:(pct,low)=>({ height:"100%", width:`${Math.min(pct,100)}%`, background:low?WARN:V, borderRadius:2, transition:"width .3s" }),
    meterSub:{ display:"flex", justifyContent:"space-between", marginTop:5, alignItems:"center" },
    meterNote:(low)=>({ fontSize:10, color:low?WARN:MUTED, fontFamily:B }),
    meterBtn:{ fontSize:10, fontWeight:700, color:V, background:"none", border:"none", cursor:"pointer", fontFamily:B, padding:0 },
    langRow: { display:"flex", gap:3, background:WHITE, borderRadius:7, padding:2, border:`1px solid ${BORDER}` },
    langBtn: (a) => ({ background:a?V:"transparent", color:a?WHITE:MUTED, border:"none", borderRadius:5, padding:"3px 9px", fontSize:10, fontWeight:700, cursor:"pointer", fontFamily:B, transition:"all .18s" }),
    main:    { padding:"2rem 2.5rem", maxWidth:760, overflowY:"auto" },
    topBar:  { display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"1.75rem" },
    greeting:{ fontFamily:H, fontSize:20, fontWeight:800, color:TEXT, letterSpacing:"-.02em" },
    newBtn:  { padding:"8px 16px", background:V, color:WHITE, border:"none", borderRadius:8, fontFamily:H, fontSize:12, fontWeight:700, cursor:"pointer", letterSpacing:"-.01em" },
    secLbl:  { fontSize:10, fontWeight:700, letterSpacing:".12em", color:V, textTransform:"uppercase", marginBottom:".3rem", fontFamily:B },
    secTitle:{ fontFamily:H, fontSize:17, fontWeight:800, color:TEXT, marginBottom:".2rem", letterSpacing:"-.02em" },
    secSub:  { fontSize:12, color:MUTED, marginBottom:"1.1rem" },
    // LIMIT MSG
    limitBox:{ background:WARN_BG, border:`1px solid #FDE68A`, borderRadius:12, padding:"1rem 1.1rem", marginBottom:"1.25rem" },
    limitTop:{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:10 },
    limitT:  { fontFamily:H, fontSize:14, fontWeight:700, color:WARN, marginBottom:4 },
    limitNote:{ fontSize:13, color:"#92400E", lineHeight:1.65, fontFamily:B },
    limitClose:{ background:"none", border:`1px solid #FDE68A`, color:WARN, borderRadius:6, padding:"4px 10px", fontSize:11, fontWeight:600, cursor:"pointer", fontFamily:B, flexShrink:0 },
    // WARN BOX
    warnBox: { background:WARN_BG, border:`1px solid #FDE68A`, borderRadius:10, padding:".65rem 1rem", display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"1.1rem" },
    warnTxt: { fontSize:12, color:WARN, fontFamily:B, fontWeight:500 },
    warnBtn: { fontSize:11, fontWeight:700, color:V, background:"none", border:"none", cursor:"pointer", fontFamily:B },
    // PROJECT GRID
    grid:    { display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:"1.25rem" },
    card:    { background:WHITE, border:`1.5px solid ${BORDER}`, borderRadius:14, overflow:"hidden", transition:"all .2s", cursor:"default" },
    cardHead:{ padding:".75rem 1rem", borderBottom:`1px solid ${BORDER}`, display:"flex", alignItems:"flex-start", justifyContent:"space-between" },
    cardName:{ fontFamily:H, fontSize:15, fontWeight:800, color:TEXT, letterSpacing:"-.02em", marginBottom:3 },
    cardType:(tipo)=>{ const c=TIPO_COLORS[tipo]||{bg:OFF,color:MUTED}; return {background:c.bg,color:c.color,fontSize:8,fontWeight:700,letterSpacing:".08em",padding:"2px 7px",borderRadius:8,textTransform:"uppercase",fontFamily:B,display:"inline-block"} },
    activeDot:{ display:"flex", alignItems:"center", gap:4 },
    greenDot:{ width:6, height:6, background:SUCCESS, borderRadius:"50%" },
    activeLabel:{ fontSize:9, color:SUCCESS, fontWeight:600, fontFamily:B },
    cardBody:{ padding:".75rem 1rem" },
    infoGrid:{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"6px 10px", marginBottom:".85rem" },
    infoLbl: { fontSize:8, fontWeight:700, letterSpacing:".1em", color:MUTED, textTransform:"uppercase", marginBottom:2, fontFamily:B },
    infoVal: { fontSize:11, color:TEXT, fontWeight:500, fontFamily:B },
    voiceBox:{ background:V_SOFT, border:`1px solid ${V_MID}`, borderRadius:7, padding:"5px 9px", marginBottom:".85rem" },
    pubBar:  { marginBottom:".85rem" },
    pubTop:  { display:"flex", justifyContent:"space-between", marginBottom:3 },
    pubLbl:  { fontSize:9, color:MUTED, fontFamily:B },
    pubNum:  { fontSize:9, fontWeight:700, color:TEXT, fontFamily:B },
    pubProg: { height:3, background:BORDER, borderRadius:2, overflow:"hidden" },
    pubFill: (pct)=>({ height:"100%", width:`${pct}%`, background:pct===100?SUCCESS:V, borderRadius:2 }),
    cardFoot:{ display:"flex", flexDirection:"column", gap:7 },
    btnOpen: { padding:"8px", background:V, color:WHITE, border:"none", borderRadius:7, fontFamily:H, fontSize:11, fontWeight:700, cursor:"pointer" },
    btnGen:  { padding:"8px", background:OFF, color:TEXT, border:`1px solid ${BORDER}`, borderRadius:7, fontFamily:B, fontSize:11, fontWeight:500, cursor:"pointer" },
    lockedCard:{ background:OFF, border:`1.5px dashed ${BORDER}`, borderRadius:14, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"1.25rem", textAlign:"center", minHeight:220, cursor:"pointer", transition:"all .2s" },
    lockedT: { fontFamily:H, fontSize:13, fontWeight:700, color:MUTED, marginBottom:".35rem" },
    lockedD: { fontSize:11, color:MUTED, lineHeight:1.55, marginBottom:".85rem" },
    lockedBtn:{ padding:"8px 14px", background:V, color:WHITE, border:"none", borderRadius:7, fontFamily:H, fontSize:11, fontWeight:700, cursor:"pointer", marginBottom:5 },
    lockedN: { fontSize:9, color:MUTED, fontFamily:B },
    upgradeBanner:{ background:`linear-gradient(135deg,${V} 0%,#4C1D95 100%)`, borderRadius:14, padding:"1.25rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", gap:"1rem" },
    upgradeT:{ fontFamily:H, fontSize:15, fontWeight:800, color:WHITE, letterSpacing:"-.02em", marginBottom:3 },
    upgradeSub:{ fontSize:12, color:"rgba(255,255,255,.7)", fontFamily:B },
    upgradeBtn:{ padding:"9px 18px", background:WHITE, color:V, border:"none", borderRadius:8, fontFamily:H, fontSize:12, fontWeight:800, cursor:"pointer", whiteSpace:"nowrap", flexShrink:0 },
    // CHARACTERS VIEW
    charHeader:{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"1.25rem" },
    charSlotBox:{ background:V_SOFT, border:`1px solid ${V_MID}`, borderRadius:10, padding:".75rem 1rem", marginBottom:"1.25rem", display:"flex", alignItems:"center", justifyContent:"space-between" },
    charSlotLbl:{ fontSize:11, color:V, fontFamily:B, fontWeight:600 },
    charSlotNum:{ fontFamily:H, fontSize:16, fontWeight:800, color:V },
    charGrid:{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, marginBottom:"1.25rem" },
    charCard:{ background:WHITE, border:`1.5px solid ${BORDER}`, borderRadius:12, overflow:"hidden", transition:"all .2s" },
    charInfo:{ padding:".75rem .85rem" },
    charName:{ fontFamily:H, fontSize:13, fontWeight:700, color:TEXT, marginBottom:2 },
    charDesc:{ fontSize:11, color:MUTED, lineHeight:1.5, fontFamily:B, marginBottom:4 },
    charMeta:{ fontSize:9, color:MUTED, fontFamily:B },
    charEmpty:{ background:OFF, border:`1.5px dashed ${BORDER}`, borderRadius:12, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"1.5rem", textAlign:"center", minHeight:160 },
    charEmptyIcon:{ fontSize:28, opacity:.3, marginBottom:".5rem" },
    charEmptyT:{ fontSize:12, color:MUTED, fontFamily:H, fontWeight:700, marginBottom:4 },
    charEmptyD:{ fontSize:11, color:MUTED, fontFamily:B, lineHeight:1.5, marginBottom:".75rem" },
    packBox:{ background:OFF, border:`1px solid ${BORDER}`, borderRadius:12, padding:"1rem 1.1rem", marginBottom:"1.25rem" },
    packTitle:{ fontSize:10, fontWeight:700, letterSpacing:".1em", color:MUTED, textTransform:"uppercase", marginBottom:".6rem", fontFamily:B },
    packRow:{ display:"flex", alignItems:"center", gap:8, marginBottom:4 },
    packName:{ fontSize:12, fontWeight:600, color:TEXT, fontFamily:B },
    packBar:{ flex:1, height:4, background:BORDER, borderRadius:2, overflow:"hidden" },
    packFill:(pct)=>({ height:"100%", width:`${pct}%`, background:V, borderRadius:2 }),
    packMeta:{ fontSize:10, color:MUTED, fontFamily:B },
    buyModal:{ position:"fixed", inset:0, background:"rgba(0,0,0,.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:200, padding:"1.5rem" },
    buyBox:{ background:WHITE, borderRadius:18, padding:"1.75rem", maxWidth:480, width:"100%" },
    buyT:{ fontFamily:H, fontSize:20, fontWeight:800, color:TEXT, marginBottom:".35rem", letterSpacing:"-.02em" },
    buySub:{ fontSize:13, color:MUTED, marginBottom:"1.25rem", lineHeight:1.65 },
    buyGrid:{ display:"grid", gridTemplateColumns:"1fr", gap:8, marginBottom:"1.1rem" },
    buyCard:(h)=>({ border:h?`2px solid ${V}`:`1.5px solid ${BORDER}`, background:h?V_SOFT:WHITE, borderRadius:12, padding:"1rem 1.1rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"relative", cursor:"pointer", transition:"all .18s" }),
    buyCardPop:{ position:"absolute", top:-9, right:"1rem", background:V, color:WHITE, fontSize:9, fontWeight:700, padding:"2px 9px", borderRadius:20, fontFamily:B },
    buyCardName:(h)=>({ fontFamily:H, fontSize:14, fontWeight:700, color:h?V:TEXT }),
    buyCardMeta:{ fontSize:11, color:MUTED, fontFamily:B, marginTop:2 },
    buyCardExpires:{ fontSize:10, color:MUTED, fontFamily:B, marginTop:2 },
    buyCardPrice:{ fontFamily:H, fontSize:20, fontWeight:800, color:h=>h?V:TEXT },
    buyBtn:{ width:"100%", padding:"12px", background:V, color:WHITE, border:"none", borderRadius:9, fontFamily:H, fontSize:13, fontWeight:700, cursor:"pointer", marginBottom:8 },
    buyClose:{ width:"100%", padding:"10px", background:"none", border:`1px solid ${BORDER}`, color:MUTED, borderRadius:9, fontFamily:B, fontSize:13, cursor:"pointer" },
    buyNote:{ fontSize:11, color:MUTED, textAlign:"center", marginTop:".6rem", fontFamily:B, fontStyle:"italic" },
    // PROFILE
    profileWrap:{ maxWidth:520 },
    profileSection:{ marginBottom:"1.75rem" },
    profileSecT:{ fontSize:10, fontWeight:700, letterSpacing:".12em", color:MUTED, textTransform:"uppercase", marginBottom:".75rem", fontFamily:B },
    profileCard:{ background:WHITE, border:`1px solid ${BORDER}`, borderRadius:12, padding:"1rem 1.1rem" },
    profileRow:{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:".5rem 0", borderBottom:`1px solid ${BORDER}` },
    profileRowLast:{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:".5rem 0" },
    profileLbl:{ fontSize:12, color:MUTED, fontFamily:B },
    profileVal:{ fontSize:12, fontWeight:600, color:TEXT, fontFamily:B },
    profileLink:{ fontSize:12, fontWeight:600, color:V, background:"none", border:"none", cursor:"pointer", fontFamily:B },
    toggleRow:{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:".5rem 0", borderBottom:`1px solid ${BORDER}` },
    toggleLbl:{ fontSize:12, color:TEXT, fontFamily:B },
    toggle:{ width:34, height:18, background:SUCCESS, borderRadius:9, position:"relative", cursor:"pointer", transition:"background .2s", flexShrink:0 },
    toggleThumb:{ position:"absolute", top:2, right:2, width:14, height:14, background:WHITE, borderRadius:"50%", transition:"right .2s" },
    referralBox:{ background:V_SOFT, border:`1px solid ${V_MID}`, borderRadius:12, padding:"1rem 1.1rem", marginBottom:"1rem" },
    referralLink:{ background:WHITE, border:`1px solid ${V_MID}`, borderRadius:8, padding:"8px 12px", fontFamily:B, fontSize:12, color:TEXT, display:"flex", alignItems:"center", justifyContent:"space-between", gap:8, marginTop:".65rem", marginBottom:".65rem" },
    referralLinkTxt:{ fontSize:11, color:MUTED, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flex:1 },
    referralCopyBtn:(copied)=>({ padding:"5px 12px", background:copied?SUCCESS:V, color:WHITE, border:"none", borderRadius:6, fontSize:11, fontWeight:600, cursor:"pointer", fontFamily:B, transition:"background .2s", flexShrink:0, whiteSpace:"nowrap" }),
    referralStats:{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 },
    referralStatCard:{ background:WHITE, borderRadius:8, padding:".6rem .75rem", textAlign:"center" },
    referralStatNum:{ fontFamily:H, fontSize:18, fontWeight:800, color:V },
    referralStatLbl:{ fontSize:10, color:MUTED, fontFamily:B },
    referralNote:{ fontSize:10, color:MUTED, fontStyle:"italic", fontFamily:B, marginTop:".5rem" },
    dangerCard:{ background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:12, padding:"1rem 1.1rem" },
    dangerT:{ fontSize:13, fontWeight:700, color:"#DC2626", fontFamily:H, marginBottom:".35rem" },
    dangerD:{ fontSize:12, color:"#EF4444", lineHeight:1.6, marginBottom:".75rem", fontFamily:B },
    dangerBtn:{ padding:"8px 16px", background:"#DC2626", color:WHITE, border:"none", borderRadius:7, fontFamily:B, fontSize:12, fontWeight:600, cursor:"pointer" },
    cancelBox:{ background:OFF, border:`1px solid ${BORDER}`, borderRadius:12, padding:"1rem 1.1rem", marginTop:".75rem" },
    cancelLbl:{ fontSize:10, fontWeight:700, letterSpacing:".1em", color:MUTED, textTransform:"uppercase", marginBottom:".4rem", fontFamily:B },
    cancelNote:{ fontSize:12, color:MUTED, lineHeight:1.6, marginBottom:".65rem", fontFamily:B },
    cancelBtn:{ padding:"8px 16px", background:"none", border:`1px solid ${BORDER}`, color:MUTED, borderRadius:7, fontFamily:B, fontSize:12, fontWeight:500, cursor:"pointer" },
  }

  const pubPct = proj ? (proj.publicados/proj.totalDias)*100 : 0

  return (
    <div style={s.page}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Manrope:wght@300;400;500;600&display=swap');
        @keyframes fi{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
        @keyframes spin{to{transform:rotate(360deg)}}
        .fi{animation:fi .3s ease}
        .proj-card:hover{border-color:${V}!important;box-shadow:0 6px 20px ${V}10!important}
        .locked-card:hover{border-color:${V}!important;background:${V_SOFT}!important}
        .char-card:hover{border-color:${V}!important}
      `}</style>

      {/* BUY CHARACTERS MODAL */}
      {view==="buy_chars" && (
        <div style={s.buyModal} onClick={()=>setView("characters")}>
          <div style={s.buyBox} onClick={e=>e.stopPropagation()} className="fi">
            <div style={s.buyT}>{t.charBuyTitle}</div>
            <div style={s.buySub}>{t.charBuyNote}</div>
            <div style={s.buyGrid}>
              {charPacks.map((pack,i)=>(
                <div key={i} style={s.buyCard(selectedCharPack===pack.id)} onClick={()=>setSelectedCharPack(pack.id)}>
                  {pack.highlight && <div style={s.buyCardPop}>{t.charBestValue}</div>}
                  <div>
                    <div style={s.buyCardName(selectedCharPack===pack.id)}>{pack.name}</div>
                    <div style={s.buyCardMeta}>{pack.unit}</div>
                    <div style={s.buyCardExpires}>{pack.expires}</div>
                  </div>
                  <div style={{ fontFamily:H, fontSize:20, fontWeight:800, color:selectedCharPack===pack.id?V:TEXT }}>{pack.price}</div>
                </div>
              ))}
            </div>
            {buyCharError && (
              <div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#DC2626",marginBottom:".75rem",fontFamily:B}}>{buyCharError}</div>
            )}
            <button style={s.buyBtn} onClick={buyCharPack} disabled={buyingCharPack}>
              {buyingCharPack ? (es?"Redirigiendo a pago...":"Redirecting to payment...") : t.charBuyBtn}
            </button>
            <button style={s.buyClose} onClick={()=>setView("characters")}>{t.charBuyClose}</button>
            <div style={s.buyNote}>
              {es?"Los personajes son por proyecto. Los paquetes vencen en 6 meses.":"Characters are per project. Packs expire in 6 months."}
            </div>
          </div>
        </div>
      )}

      {/* BUY IMAGES MODAL */}
      {view==="buy_imgs" && (
        <div style={s.buyModal} onClick={()=>setView("dashboard")}>
          <div style={s.buyBox} onClick={e=>e.stopPropagation()} className="fi">
            <div style={s.buyT}>{es?"Comprar imágenes":"Buy images"}</div>
            <div style={s.buySub}>{es?"Agrega imágenes a tu cupo del mes actual.":"Add images to your current month quota."}</div>
            <div style={{background:SUCCESS_BG,border:`1px solid ${SUCCESS_MID}`,borderRadius:8,padding:"8px 12px",marginBottom:"1rem",fontSize:12,color:SUCCESS,fontFamily:B}}>
              ✓ {es?"Los paquetes que compras no vencen nunca. Se acumulan hasta que los uses.":"Packs you buy never expire. They accumulate until you use them."}
              <div style={{fontSize:11,color:MUTED,marginTop:3}}>⚡ {es?"Imágenes en estilo Animado 3D cuentan como 2 créditos.":"Images in Animado 3D style count as 2 credits."}</div>
            </div>
            <div style={s.buyGrid}>
              {imgPacks.map((pack,i)=>(
                <div key={i} style={s.buyCard(selectedPack===pack.id)} onClick={()=>setSelectedPack(pack.id)}>
                  <div>
                    <div style={s.buyCardName(selectedPack===pack.id)}>{pack.name}</div>
                    <div style={s.buyCardMeta}>{pack.imgs}</div>
                  </div>
                  <div style={{ fontFamily:H, fontSize:20, fontWeight:800, color:TEXT }}>{pack.price}</div>
                </div>
              ))}
            </div>
            {buyError && (
              <div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#DC2626",marginBottom:".75rem",fontFamily:B}}>{buyError}</div>
            )}
            <button style={s.buyBtn} onClick={buyPack} disabled={buyingPack}>
              {buyingPack ? (es?"Redirigiendo a pago...":"Redirecting to payment...") : (es?"Comprar →":"Buy →")}
            </button>
            <button style={s.buyClose} onClick={()=>setView("dashboard")}>{t.charBuyClose}</button>
          </div>
        </div>
      )}

      {/* SIDEBAR */}
      <div style={s.sidebar}>
        <div style={s.sideTop}>
          <div style={s.logo}>KORIVA <span style={s.logoV}>Studio™</span></div>
          <div style={s.userCard}>
            <div style={s.userName}>{user.name}</div>
            <div style={s.planRow}>
              <div style={s.planBadge}>{user.planLabel[lang]}</div>
              <button style={s.upgradeLink} onClick={()=>setView("profile")}>{t.upgrade}</button>
            </div>
          </div>
        </div>

        <div style={s.navWrap}>
          {nav.map(item=>(
            <div key={item.id} style={s.navItem(view===item.id)} onClick={async ()=>{
              if (item.id === "logout") {
                await supabase.auth.signOut()
                navigate("/login")
              } else {
                setView(item.id)
              }
            }}>
              <span style={s.navLabel(view===item.id)}>{item.label}</span>
            </div>
          ))}
        </div>

        <div style={s.sideBottom}>
          {/* IMAGES METER */}
          <div style={s.meterRow}>
            <div style={s.meterTop}>
              <span style={s.meterLbl}>{t.imgTitle}</span>
              <span style={s.meterNum(imgLow)}>{user.imgUsed}/{user.imgTotal}</span>
            </div>
            <div style={s.meterBar}><div style={s.meterFill(imgPct,imgLow)}/></div>
            <div style={s.meterSub}>
              <span style={s.meterNote(imgLow)}>{user.imgTotal-user.imgUsed} {es?"disponibles":"available"}</span>
              <button style={s.meterBtn} onClick={()=>setView("buy_imgs")}>{t.imgAdd}</button>
            </div>
            <div style={{fontSize:10,color:SUCCESS,fontFamily:B,marginTop:5}}>
              ✓ {es?"Paquetes extra no vencen":"Extra packs never expire"}
            </div>
            <div style={{fontSize:10,color:MUTED,fontFamily:B,marginTop:3}}>
              ⚡ {es?"Animado 3D = 2 créditos por imagen":"Animado 3D = 2 credits per image"}
            </div>
          </div>

          {/* CHARACTERS FROM PLAN METER */}
          <div style={s.meterRow}>
            <div style={s.meterTop}>
              <span style={s.meterLbl}>{es?"Personajes del plan":"Plan characters"}</span>
              <span style={s.meterNum(false)}>{Math.min(charsCreadosUsuario, charSlotsPorPlan)}/{charSlotsPorPlan}</span>
            </div>
            <div style={s.meterSub}>
              <span style={s.meterNote(false)}>{es?`Plan ${user.plan==="agency"?"Agency":user.plan==="growth"?"Growth":"Starter"} incluye ${charSlotsPorPlan} ${charSlotsPorPlan===1?"personaje":"personajes"}`:`${user.plan==="agency"?"Agency":user.plan==="growth"?"Growth":"Starter"} plan includes ${charSlotsPorPlan}`}</span>
            </div>
          </div>

          {/* CHARACTERS PURCHASED METER */}
          <div style={s.meterRow}>
            <div style={s.meterTop}>
              <span style={s.meterLbl}>{es?"Personajes comprados":"Purchased characters"}</span>
              <span style={s.meterNum(false)}>{user.charCreditsExtra || 0}</span>
            </div>
            <div style={s.meterSub}>
              <span style={s.meterNote(false)}>{es?"disponibles":"available"}</span>
              <button style={s.meterBtn} onClick={()=>setView("buy_chars")}>{es?"Comprar más":"Buy more"}</button>
            </div>
            <div style={{fontSize:10,color:SUCCESS,fontFamily:B,marginTop:5}}>
              ✓ {es?"No vencen":"Never expire"}
            </div>
          </div>

          {/* GENERATIONS METER */}
          <div style={s.meterRow}>
            <div style={s.meterTop}>
              <span style={s.meterLbl}>{t.genTitle}</span>
              <span style={s.meterNum(genLow)}>{user.genUsedToday}</span>
            </div>
            <div style={s.meterBar}><div style={s.meterFill(genPct,genLow)}/></div>
          </div>

          <div style={s.langRow}>
            {["es","en"].map(l=>(
              <button key={l} style={s.langBtn(lang===l)} onClick={()=>setLang(l)}>{l.toUpperCase()}</button>
            ))}
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div style={s.main}>

        {/* ── ADN DE PROYECTOS ── */}
        {view==="adn" && (
          <div className="fi">
            <div style={{ fontSize:11, fontWeight:700, letterSpacing:".12em", color:V, textTransform:"uppercase", fontFamily:B, marginBottom:".3rem" }}>
              {lang==="es" ? "ADN de proyectos" : "Brand DNA"}
            </div>
            <div style={{ fontSize:26, fontWeight:800, color:TEXT, fontFamily:H, marginBottom:".4rem", letterSpacing:"-.02em" }}>
              {lang==="es" ? "La esencia de cada proyecto" : "The essence of each project"}
            </div>
            <div style={{ fontSize:13, color:MUTED, fontFamily:B, marginBottom:"1.5rem" }}>
              {lang==="es" ? "Elige un proyecto para ver cómo te lee la IA, tu voz de marca y tus clientes ideales." : "Pick a project to see how AI reads you, your brand voice and ideal customers."}
            </div>
            {adnProyecto ? (
              <AdnDetalle
                proyecto={projects.find(p=>p.id===adnProyecto)}
                datos={adnDatos}
                cargando={adnCargando}
                lang={lang}
                onVolver={()=>setAdnProyecto(null)}
              />
            ) : (
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(280px, 1fr))", gap:"1rem" }}>
              {projects.map(p => (
                <div key={p.id}
                  onClick={()=>setAdnProyecto(p.id)}
                  style={{ padding:"1.2rem 1.3rem", background:WHITE, border:`1px solid ${BORDER}`, borderRadius:14, cursor:"pointer", transition:"all .15s",
                    boxShadow:"0 1px 3px rgba(0,0,0,.04)" }}
                  onMouseEnter={e=>{ e.currentTarget.style.borderColor=V; e.currentTarget.style.boxShadow="0 4px 14px rgba(124,58,237,.12)" }}
                  onMouseLeave={e=>{ e.currentTarget.style.borderColor=BORDER; e.currentTarget.style.boxShadow="0 1px 3px rgba(0,0,0,.04)" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:".6rem" }}>
                    <div style={{ fontSize:16, fontWeight:800, color:TEXT, fontFamily:H, letterSpacing:"-.01em" }}>{p.nombre[lang]||p.nombre.es}</div>
                    {p.active && <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                      <div style={{ width:7, height:7, borderRadius:"50%", background:"#22C55E" }}/>
                      <span style={{ fontSize:10, color:"#22C55E", fontWeight:700, fontFamily:B }}>{lang==="es"?"Activo":"Active"}</span>
                    </div>}
                  </div>
                  <div style={{ fontSize:11, color:MUTED, fontFamily:B, textTransform:"uppercase", letterSpacing:".04em", marginBottom:".8rem" }}>{p.tipo[lang]||p.tipo.es}</div>
                  <div style={{ display:"flex", alignItems:"center", gap:6, color:V, fontSize:12, fontWeight:700, fontFamily:B }}>
                    <span>{lang==="es" ? "Ver ADN" : "View DNA"}</span>
                    <span>→</span>
                  </div>
                </div>
              ))}
            </div>
            )}
          </div>
        )}

        {/* ── DASHBOARD ── */}
        {view==="dashboard" && (
          <div className="fi">
            <div style={s.topBar}>
              <div style={s.greeting}>{t.greeting}, {user.name.split(" ")[0]} 👋</div>
              <button style={s.newBtn} onClick={()=>{
                const slots = user.plan==="agency" ? 20 : user.plan==="growth" ? 5 : 1
                if (projects.length >= slots) { setView("profile") }
                else { window.location.href = "/onboarding?nuevo=true" }
              }}>
                {t.newProject}
              </button>
            </div>

            {/* GENERATION LIMIT MESSAGE */}
            {showLimitMsg && (
              <div style={s.limitBox}>
                <div style={s.limitTop}>
                  <div>
                    <div style={s.limitT}>⏱ {t.genLimit}</div>
                    <div style={s.limitNote}>{t.genLimitNote}</div>
                  </div>
                  <button style={s.limitClose} onClick={()=>setShowLimitMsg(false)}>{t.genLimitClose}</button>
                </div>
              </div>
            )}

            {/* IMG WARNING */}
            {imgLow && (
              <div style={s.warnBox}>
                <span style={s.warnTxt}>⚠️ {es?`Te quedan ${user.imgTotal-user.imgUsed} imágenes este mes.`:`${user.imgTotal-user.imgUsed} images left this month.`}</span>
                <button style={s.warnBtn} onClick={()=>setView("buy_imgs")}>{t.imgAdd}</button>
              </div>
            )}

            <div style={s.secLbl}>{t.projectsTitle}</div>
            <div style={{ ...s.secTitle, marginBottom:".2rem" }}>{es?`${projects.length} ${projects.length===1?"proyecto activo":"proyectos activos"}`:`${projects.length} active ${projects.length===1?"project":"projects"}`}</div>
            <div style={{ ...s.secSub, marginBottom:"1.1rem" }}>{t.projectsSub}</div>

            <div style={s.grid}>
              {projects.map(p=>(
                <div key={p.id} className="proj-card" style={s.card}>
                  <div style={s.cardHead}>
                    <div>
                      <div style={s.cardName}>{p.nombre[lang]||p.nombre.es}</div>
                      <span style={s.cardType(p.tipo[lang]||p.tipo.es)}>{p.tipo[lang]||p.tipo.es}</span>
                    </div>
                    {p.active && <div style={s.activeDot}><div style={s.greenDot}/><span style={s.activeLabel}>{es?"Activo":"Active"}</span></div>}
                  </div>
                  <div style={s.cardBody}>
                    <div style={s.infoGrid}>
                      <div><div style={s.infoLbl}>{t.weekLabel}</div><div style={s.infoVal}>{p.semana[lang]||p.semana.es}</div></div>
                      <div><div style={s.infoLbl}>{t.focusLabel}</div><div style={s.infoVal}>{p.enfoque[lang]||p.enfoque.es}</div></div>
                      <div><div style={s.infoLbl}>{t.styleLabel}</div><div style={s.infoVal}>{p.estilo}</div></div>
                      <div><div style={s.infoLbl}>{t.marketLabel}</div><div style={s.infoVal}>{p.mercado[lang]||p.mercado.es}</div></div>
                      <div><div style={s.infoLbl}>{t.personasLabel}</div><div style={s.infoVal}>{p.personas}</div></div>
                      <div><div style={s.infoLbl}>{t.lastGenLabel}</div><div style={s.infoVal}>{p.ultimaGen[lang]||p.ultimaGen.es}</div></div>
                    </div>
                    <div style={s.voiceBox}>
                      <div style={s.infoLbl}>{t.voiceLabel}</div>
                      <div style={{ fontSize:10, color:V, fontStyle:"italic", fontFamily:B }}>{p.voz[lang]||p.voz.es}</div>
                    </div>
                    <div style={s.pubBar}>
                      <div style={s.pubTop}>
                        <span style={s.pubLbl}>{t.publishedLabel}</span>
                        <span style={s.pubNum}>{p.publicados} {t.of} {p.totalDias} {t.days}</span>
                      </div>
                      <div style={s.pubProg}><div style={s.pubFill((p.publicados/p.totalDias)*100)}/></div>
                    </div>
                    <div style={s.cardFoot}>
                      <button style={s.btnOpen} onClick={()=>abrirProyecto(p.id, "/archive")}>{t.openProject}</button>
                      <button style={s.btnOpen} onClick={()=>{ if(user.genUsedToday>=user.genLimitDay){setShowLimitMsg(true)} else {abrirProyecto(p.id, "/weekly")} }}>{t.generateWeek}</button>
                      <button style={s.btnOpen} onClick={()=>abrirProyecto(p.id, "/brand-form")}>{t.editMarca}</button>
                      <button style={s.btnOpen} onClick={()=>abrirProyecto(p.id, "/tracker")}>{t.verMetricas}</button>
                      {(() => {
                        const ahora = Date.now()
                        const ultimoReanalisis = user.lastDnaReanalysis ? new Date(user.lastDnaReanalysis).getTime() : null
                        const diasDesde = ultimoReanalisis ? (ahora - ultimoReanalisis) / (1000 * 60 * 60 * 24) : 999
                        const habilitado = diasDesde >= 30
                        const diasFaltan = Math.ceil(30 - diasDesde)
                        return (
                          <button
                            style={habilitado ? s.btnOpen : { ...s.btnOpen, opacity: 0.5, cursor: "not-allowed" }}
                            onClick={() => habilitado && setReanalisisProyecto(p.id)}
                            disabled={!habilitado}
                          >
                            {habilitado
                              ? (es ? "Re-analizar ADN" : "Re-analyze DNA")
                              : (es ? `Disponible en ${diasFaltan} dias` : `Available in ${diasFaltan} days`)}
                          </button>
                        )
                      })()}
                    </div>
                  </div>
                </div>
              ))}

              {/* LOCKED SLOT */}
              {(() => {
                const limitePlan = user.plan==="agency" ? 20 : user.plan==="growth" ? 5 : 1
                const quedanSlots = projects.length < limitePlan
                const proximoPlan = user.plan==="starter" ? "Growth" : user.plan==="growth" ? "Agency" : null
                const proximoPrecio = user.plan==="starter" ? "$87" : user.plan==="growth" ? "$147" : null
                const proximoMax = user.plan==="starter" ? 5 : user.plan==="growth" ? 20 : null

                if (quedanSlots) {
                  // Hay espacio: invitar a crear el siguiente proyecto
                  return (
                    <div className="locked-card" style={s.lockedCard} onClick={()=>window.location.href="/onboarding?nuevo=true"}>
                      <div style={{ fontSize:24, opacity:.5, marginBottom:".6rem" }}>＋</div>
                      <div style={s.lockedT}>{es ? "Crea tu siguiente proyecto" : "Create your next project"}</div>
                      <div style={s.lockedD}>{es ? `Tu plan ${user.plan} permite hasta ${limitePlan}. Llevas ${projects.length}.` : `Your ${user.plan} plan allows up to ${limitePlan}. You have ${projects.length}.`}</div>
                      <button style={s.lockedBtn} onClick={e=>{e.stopPropagation();window.location.href="/onboarding?nuevo=true"}}>{es ? "+ Nuevo proyecto" : "+ New project"}</button>
                    </div>
                  )
                }
                if (proximoPlan) {
                  // Topo el limite pero puede subir de plan
                  return (
                    <div className="locked-card" style={s.lockedCard} onClick={()=>setView("profile")}>
                      <div style={{ fontSize:24, opacity:.35, marginBottom:".6rem" }}>🔒</div>
                      <div style={s.lockedT}>{es ? `Slot disponible con ${proximoPlan}` : `Slot available with ${proximoPlan}`}</div>
                      <div style={s.lockedD}>{es ? `Tu plan ${user.plan} llegó a ${limitePlan}. Sube a ${proximoPlan} para gestionar hasta ${proximoMax}.` : `Your ${user.plan} plan reached ${limitePlan}. Upgrade to ${proximoPlan} to manage up to ${proximoMax}.`}</div>
                      <button style={s.lockedBtn} onClick={e=>{e.stopPropagation();setView("profile")}}>{es ? `Subir a ${proximoPlan} — ${proximoPrecio}/mes →` : `Upgrade to ${proximoPlan} — ${proximoPrecio}/mo →`}</button>
                      <div style={s.lockedN}>{es?"Precio de lanzamiento":"Launch price"}</div>
                    </div>
                  )
                }
                return null // Agency al maximo: no mostrar tarjeta
              })()}
            </div>

            <div style={s.upgradeBanner}>
              <div>
                <div style={s.upgradeT}>{t.upgradeBanner}</div>
                <div style={s.upgradeSub}>{t.upgradeBannerSub}</div>
              </div>
              <button style={s.upgradeBtn} onClick={()=>setView("profile")}>{t.upgradeBannerBtn}</button>
            </div>
          </div>
        )}

        {/* ── CHARACTERS ── */}
        {view==="characters" && (
          <div className="fi">
            <div style={s.charHeader}>
              <div>
                <div style={s.secLbl}>{t.charsTitle} {proj?.nombre[lang]||proj?.nombre.es}</div>
                <div style={s.secTitle}>{es?"Mis personajes":"My characters"}</div>
                <div style={{ ...s.secSub, marginBottom:0 }}>{t.charsSub}</div>
              </div>
              <div style={{ display:"flex", gap:8 }}>
                <button style={{ padding:"8px 14px", background:OFF, color:MUTED, border:`1px solid ${BORDER}`, borderRadius:8, fontFamily:B, fontSize:12, fontWeight:500, cursor:"pointer" }} onClick={()=>setView("buy_chars")}>
                  {t.charBuy}
                </button>
                <button style={{ padding:"8px 14px", background:WHITE, color:V, border:`1.5px solid ${V}`, borderRadius:8, fontFamily:H, fontSize:12, fontWeight:700, cursor:"pointer" }} onClick={()=>setView("upload_char")}>
                  {es?"⬆ Subir mi personaje":"⬆ Upload my character"}
                </button>
                <button style={{ padding:"8px 14px", background:V, color:WHITE, border:"none", borderRadius:8, fontFamily:H, fontSize:12, fontWeight:700, cursor:"pointer" }} onClick={()=>setView("create_char")}>
                  {t.charNew}
                </button>
              </div>
            </div>

            {/* CHARACTER GRID */}
            <div style={s.charGrid}>
              {proj?.characters?.map((char,i)=>(
                <div key={i} className="char-card" style={s.charCard}>
                  {char.imagen_url
                    ? <img src={char.imagen_url} alt={char.name} style={{ width:"100%", aspectRatio:"1", objectFit:"contain", background:OFF, borderRadius:"12px 12px 0 0", display:"block" }}/>
                    : <CharacterMockup character={char} style={char.style}/>}
                  <div style={s.charInfo}>
                    <div style={s.charName}>{char.name}</div>
                    <div style={s.charDesc}>{(char.desc[lang]||char.desc.es||"").slice(0,80)}</div>
                    <div style={s.charMeta}>{char.style} · {char.created[lang]||char.created.es}</div>
                  </div>
                </div>
              ))}

              {/* EMPTY SLOT */}
              {totalCharsAvailable > charsUsed && (
                <div style={s.charEmpty}>
                  <div style={s.charEmptyIcon}>🎭</div>
                  <div style={s.charEmptyT}>{es?"Nuevo personaje":"New character"}</div>
                  <div style={s.charEmptyD}>{es?"Crea un personaje y úsalo en cualquier campaña":"Create a character and use it in any campaign"}</div>
                  <button style={{ padding:"7px 14px", background:V, color:WHITE, border:"none", borderRadius:7, fontFamily:H, fontSize:11, fontWeight:700, cursor:"pointer" }} onClick={()=>setView("create_char")}>
                    {t.charNew}
                  </button>
                </div>
              )}

              {/* LOCKED SLOT */}
              {totalCharsAvailable <= charsUsed && (
                <div style={{ ...s.charEmpty, cursor:"pointer" }} onClick={()=>setView("buy_chars")}>
                  <div style={{ fontSize:20, opacity:.3, marginBottom:".4rem" }}>🔒</div>
                  <div style={s.charEmptyT}>{es?"Agregar personaje":"Add character"}</div>
                  <div style={s.charEmptyD}>{es?"Desde $9 · Por proyecto · Pago único":"From $9 · Per project · One-time payment"}</div>
                  <button style={{ padding:"7px 14px", background:V, color:WHITE, border:"none", borderRadius:7, fontFamily:H, fontSize:11, fontWeight:700, cursor:"pointer" }}>
                    {t.charBuy}
                  </button>
                </div>
              )}
            </div>

            {/* PIXAR NOTE */}
            <div style={{ background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:10, padding:".75rem 1rem", fontSize:12, color:"#92400E", fontFamily:B, lineHeight:1.65 }}>
              💡 {es
                ?"KORIVA guarda la descripción de tu personaje y la aplica en cada generación para mantener la mayor consistencia posible. El personaje estará disponible en todas tus campañas semanales de este proyecto."
                :"KORIVA saves your character's description and applies it in every generation to maintain the highest possible consistency. The character will be available in all your weekly campaigns for this project."
              }
              <div style={{marginTop:6,fontWeight:700,color:"#7C3AED"}}>
                ⚡ {es?"Los personajes Animado 3D cuentan como 2 créditos de imagen por generación.":"Animado 3D characters count as 2 image credits per generation."}
              </div>
            </div>
          </div>
        )}

        {/* ── CREAR PERSONAJE ── */}
        {view==="upload_char" && (
          <div className="fi">
            <div style={{ maxWidth: 560, margin: "0 auto" }}>
              <div style={s.secLbl}>{es?"SUBIR PERSONAJE":"UPLOAD CHARACTER"}</div>
              <div style={s.secTitle}>{es?"Sube tu propio personaje":"Upload your own character"}</div>
              <div style={{ ...s.secSub, marginBottom:"1.5rem" }}>
                {es?"¿Ya tienes un personaje 3D? Súbelo aquí gratis y úsalo en tus campañas igual que los creados con KORIVA. (Generar imágenes con él consume créditos normalmente.)":"Already have a 3D character? Upload it here for free and use it in your campaigns just like the ones made with KORIVA. (Generating images with it uses credits as usual.)"}
              </div>

              {/* Resultado: personaje subido */}
              {charCreado && (
                <div style={{ marginBottom:"1.5rem", padding:"1.2rem", background:V_SOFT, border:`1px solid ${V_MID}`, borderRadius:12, textAlign:"center" }}>
                  <div style={{ fontSize:14, fontWeight:700, color:V, fontFamily:H, marginBottom:10 }}>
                    {es?"¡Tu personaje está guardado! 🎉":"Your character is saved! 🎉"}
                  </div>
                  <img src={charCreado.imagen_url} alt={charCreado.nombre} style={{ width:200, height:200, objectFit:"cover", borderRadius:12, display:"block", margin:"0 auto 10px" }}/>
                  <div style={{ fontSize:15, fontWeight:700, color:TEXT, fontFamily:H }}>{charCreado.nombre}</div>
                  <button onClick={()=>{ setCharCreado(null); setUploadCharForm({ nombre:"", foto:null }); setView("characters") }}
                    style={{ marginTop:12, padding:"9px 18px", background:V, color:WHITE, border:"none", borderRadius:8, fontFamily:H, fontSize:13, fontWeight:700, cursor:"pointer" }}>
                    {es?"Ver mis personajes":"View my characters"}
                  </button>
                </div>
              )}

              {/* Formulario de subir (se oculta si ya se subio) */}
              {!charCreado && (
                <div style={{ background:WHITE, border:`1px solid ${BORDER}`, borderRadius:12, padding:"1.5rem" }}>
                  <div style={{ fontSize:13, fontWeight:700, color:TEXT, fontFamily:H, marginBottom:6 }}>{es?"Nombre del personaje":"Character name"}</div>
                  <input type="text" value={uploadCharForm.nombre}
                    onChange={e=>setUploadCharForm({...uploadCharForm, nombre:e.target.value})}
                    placeholder={es?"Ej: Panchito":"E.g. Panchito"}
                    style={{ width:"100%", padding:"10px 12px", borderRadius:8, border:`1px solid ${BORDER}`, fontFamily:B, fontSize:13, marginBottom:"1.2rem", boxSizing:"border-box" }}/>

                  <div style={{ fontSize:13, fontWeight:700, color:TEXT, fontFamily:H, marginBottom:6 }}>{es?"Foto del personaje":"Character photo"}</div>
                  <input type="file" accept="image/*"
                    onChange={e=>{
                      const file = e.target.files[0]
                      if (!file) return
                      const reader = new FileReader()
                      reader.onload = () => setUploadCharForm(prev=>({...prev, foto: reader.result}))
                      reader.readAsDataURL(file)
                    }}
                    style={{ width:"100%", fontFamily:B, fontSize:13, marginBottom:"1rem" }}/>

                  {uploadCharForm.foto && (
                    <img src={uploadCharForm.foto} alt="preview" style={{ width:160, height:160, objectFit:"cover", borderRadius:12, display:"block", marginBottom:"1.2rem", border:`1px solid ${BORDER}` }}/>
                  )}

                  <div style={{ display:"flex", gap:10 }}>
                    <button onClick={()=>{ setUploadCharForm({ nombre:"", foto:null }); setView("characters") }}
                      style={{ padding:"10px 18px", background:OFF, color:MUTED, border:`1px solid ${BORDER}`, borderRadius:8, fontFamily:H, fontSize:13, fontWeight:600, cursor:"pointer" }}>
                      {es?"Cancelar":"Cancel"}
                    </button>
                    <button onClick={subirPersonaje} disabled={subiendoChar || !uploadCharForm.nombre || !uploadCharForm.foto}
                      style={{ flex:1, padding:"10px 18px", background:V, color:WHITE, border:"none", borderRadius:8, fontFamily:H, fontSize:13, fontWeight:700, cursor:"pointer", opacity:(subiendoChar || !uploadCharForm.nombre || !uploadCharForm.foto)?0.5:1 }}>
                      {subiendoChar ? (es?"Guardando...":"Saving...") : (es?"Guardar personaje (gratis)":"Save character (free)")}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {view==="create_char" && (
          <div className="fi">
            <div style={{ maxWidth: 560, margin: "0 auto" }}>
              <div style={s.secLbl}>{es?"NUEVO PERSONAJE":"NEW CHARACTER"}</div>
              <div style={s.secTitle}>{es?"Crea tu personaje 3D":"Create your 3D character"}</div>
              <div style={{ ...s.secSub, marginBottom:"1.5rem" }}>
                {es?"Responde unas preguntas simples. KORIVA crea un personaje 3D que podrás reutilizar en todas tus campañas.":"Answer a few simple questions. KORIVA creates a 3D character you can reuse in all your campaigns."}
              </div>

              {/* Resultado: personaje creado */}
              {charCreado && (
                <div style={{ marginBottom:"1.5rem", padding:"1.2rem", background:V_SOFT, border:`1px solid ${V_MID}`, borderRadius:12, textAlign:"center" }}>
                  <div style={{ fontSize:14, fontWeight:700, color:V, fontFamily:H, marginBottom:10 }}>
                    {es?"¡Tu personaje está listo! 🎉":"Your character is ready! 🎉"}
                  </div>
                  <img src={charCreado.imagen_url} alt={charCreado.nombre} style={{ width:200, height:200, objectFit:"cover", borderRadius:12, display:"block", margin:"0 auto 10px" }}/>
                  <div style={{ fontSize:15, fontWeight:700, color:TEXT, fontFamily:H }}>{charCreado.nombre}</div>
                  <button onClick={()=>{ setCharCreado(null); setCharForm({ nombre:"", que_es:"", personalidad:"", extra:"" }); setView("characters") }}
                    style={{ marginTop:12, padding:"9px 18px", background:V, color:WHITE, border:"none", borderRadius:8, fontFamily:H, fontSize:13, fontWeight:700, cursor:"pointer" }}>
                    {es?"Ver mis personajes":"View my characters"}
                  </button>
                </div>
              )}

              {/* Pregunta 1: nombre */}
              <div style={{ marginBottom:"1.2rem" }}>
                <label style={{ display:"block", fontSize:13, fontWeight:700, color:TEXT, fontFamily:H, marginBottom:6 }}>
                  {es?"¿Cómo se llama tu personaje?":"What's your character's name?"}
                </label>
                <input type="text" value={charForm.nombre}
                  onChange={e=>setCharForm({...charForm, nombre:e.target.value})}
                  placeholder={es?"Ej: Panchito":"E.g: Panchito"}
                  style={{ width:"100%", padding:"10px 12px", border:`1px solid ${BORDER}`, borderRadius:8, fontFamily:B, fontSize:14, boxSizing:"border-box" }}/>
              </div>

              {/* Pregunta 2: que es */}
              <div style={{ marginBottom:"1.2rem" }}>
                <label style={{ display:"block", fontSize:13, fontWeight:700, color:TEXT, fontFamily:H, marginBottom:6 }}>
                  {es?"¿Qué es tu personaje?":"What is your character?"}
                </label>
                <input type="text" value={charForm.que_es}
                  onChange={e=>setCharForm({...charForm, que_es:e.target.value})}
                  placeholder={es?"Ej: un pan artesanal, una taza de café":"E.g: an artisan bread, a coffee cup"}
                  style={{ width:"100%", padding:"10px 12px", border:`1px solid ${BORDER}`, borderRadius:8, fontFamily:B, fontSize:14, boxSizing:"border-box" }}/>
              </div>

              {/* Pregunta 3: personalidad */}
              <div style={{ marginBottom:"1.2rem" }}>
                <label style={{ display:"block", fontSize:13, fontWeight:700, color:TEXT, fontFamily:H, marginBottom:6 }}>
                  {es?"¿Qué personalidad tiene?":"What personality does it have?"}
                </label>
                <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                  {[
                    {id:"relajado", label:es?"Relajado y carismático":"Relaxed & charming"},
                    {id:"elegante", label:es?"Elegante y premium":"Elegant & premium"},
                    {id:"divertido", label:es?"Divertido y juguetón":"Fun & playful"},
                    {id:"tierno", label:es?"Tierno y amigable":"Cute & friendly"},
                  ].map(p=>(
                    <button key={p.id}
                      onClick={()=>setCharForm({...charForm, personalidad:p.id})}
                      style={{ padding:"8px 14px", borderRadius:8, fontFamily:B, fontSize:13, cursor:"pointer",
                        border: charForm.personalidad===p.id ? `2px solid ${V}` : `1px solid ${BORDER}`,
                        background: charForm.personalidad===p.id ? V_SOFT : WHITE,
                        color: charForm.personalidad===p.id ? V : TEXT, fontWeight: charForm.personalidad===p.id ? 700 : 500 }}>
                      {p.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Pregunta 4: extra */}
              <div style={{ marginBottom:"1.8rem" }}>
                <label style={{ display:"block", fontSize:13, fontWeight:700, color:TEXT, fontFamily:H, marginBottom:6 }}>
                  {es?"¿Algo más que lo haga especial?":"Anything else that makes it special?"} <span style={{ color:MUTED, fontWeight:400 }}>({es?"opcional":"optional"})</span>
                </label>
                <input type="text" value={charForm.extra}
                  onChange={e=>setCharForm({...charForm, extra:e.target.value})}
                  placeholder={es?"Ej: europeo sin ser sofisticado, colores cálidos":"E.g: European but not fancy, warm colors"}
                  style={{ width:"100%", padding:"10px 12px", border:`1px solid ${BORDER}`, borderRadius:8, fontFamily:B, fontSize:14, boxSizing:"border-box" }}/>
              </div>

              {/* Botones */}
              <div style={{ display:"flex", gap:10 }}>
                <button onClick={()=>setView("characters")}
                  style={{ padding:"11px 20px", background:OFF, color:MUTED, border:`1px solid ${BORDER}`, borderRadius:8, fontFamily:B, fontSize:13, fontWeight:500, cursor:"pointer" }}>
                  {es?"Cancelar":"Cancel"}
                </button>
                <button
                  disabled={!charForm.nombre || !charForm.que_es || !charForm.personalidad || creandoChar}
                  onClick={crearPersonaje}
                  style={{ flex:1, padding:"11px 20px", border:"none", borderRadius:8, fontFamily:H, fontSize:13, fontWeight:700,
                    cursor: (!charForm.nombre || !charForm.que_es || !charForm.personalidad || creandoChar) ? "not-allowed" : "pointer",
                    background: (!charForm.nombre || !charForm.que_es || !charForm.personalidad) ? "#ccc" : V,
                    opacity: creandoChar ? 0.85 : 1,
                    color:WHITE, display:"flex", alignItems:"center", justifyContent:"center", gap:8 }}>
                  {creandoChar && <span style={{ width:14, height:14, border:"2px solid rgba(255,255,255,0.4)", borderTop:"2px solid #FFF", borderRadius:"50%", animation:"spin .8s linear infinite", display:"inline-block" }}/>}
                  {creandoChar ? (es?"Creando tu personaje...":"Creating your character...") : (es?"Crear personaje 🎭":"Create character 🎭")}
                </button>
              </div>
              {creandoChar && (
                <div style={{ marginTop:14, padding:"12px 16px", background:V_SOFT, border:`1px solid ${V_MID}`, borderRadius:8, fontSize:13, color:TEXT, fontFamily:B, fontStyle:"italic", textAlign:"center", lineHeight:1.5, transition:"opacity .3s" }}>
                  {wellnessMsgs[es?"es":"en"][wellnessIdx]}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── PROFILE ── */}
        {view==="profile" && (
          <div className="fi">
            <div style={{ fontFamily:H, fontSize:20, fontWeight:800, color:TEXT, letterSpacing:"-.02em", marginBottom:"1.75rem" }}>{t.profileTitle}</div>

            <div style={s.profileWrap}>

              {/* PLAN */}
              <div style={s.profileSection}>
                <div style={s.profileSecT}>{t.planSection}</div>
                <div style={s.profileCard}>
                  <div style={s.profileRow}>
                    <span style={s.profileLbl}>{t.planActive}</span>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <span style={s.planBadge}>{user.planLabel[lang]}</span>
                    </div>
                  </div>
                  {(user.plan==="starter" || user.plan==="growth") && (
                    <div style={{ display:"flex", flexDirection:"column", gap:8, marginTop:12, paddingTop:12, borderTop:`1px solid ${BORDER}` }}>
                      <div style={{ fontSize:12, color:MUTED, fontFamily:B, marginBottom:2 }}>
                        {lang==="es" ? "Mejora tu plan para gestionar más proyectos:" : "Upgrade your plan to manage more projects:"}
                      </div>
                      {user.plan==="starter" && (
                        <button onClick={()=>upgradePlan("growth")} style={{ width:"100%", padding:"11px", border:"none", borderRadius:8, background:V, color:WHITE, fontFamily:H, fontSize:13, fontWeight:700, cursor:"pointer" }}>
                          {lang==="es" ? "Subir a Growth — $87/mes (5 proyectos)" : "Upgrade to Growth — $87/mo (5 projects)"}
                        </button>
                      )}
                      <button onClick={()=>upgradePlan("agency")} style={{ width:"100%", padding:"11px", border:`1.5px solid ${V}`, borderRadius:8, background:WHITE, color:V, fontFamily:H, fontSize:13, fontWeight:700, cursor:"pointer" }}>
                        {lang==="es" ? "Subir a Agency — $147/mes (20 proyectos)" : "Upgrade to Agency — $147/mo (20 projects)"}
                      </button>
                    </div>
                  )}
                  <div style={s.profileRow}>
                    <span style={s.profileLbl}>{t.planRenew}</span>
                    <span style={s.profileVal}>{user.renewDate[lang]}</span>
                  </div>
                  <div style={s.profileRowLast}>
                    <span style={s.profileLbl}>{t.planJoin}</span>
                    <span style={s.profileVal}>{user.joinDate[lang]}</span>
                  </div>
                </div>
                <div style={s.cancelBox}>
                  <div style={s.cancelLbl}>{es?"Cancelar suscripción":"Cancel subscription"}</div>
                  <div style={s.cancelNote}>{t.cancelNote}</div>
                  <button style={s.cancelBtn} onClick={cancelarSuscripcion}>{t.planCancel}</button>
                </div>
              </div>

              {/* NOTIFICATIONS */}
              <div style={s.profileSection}>
                <div style={s.profileSecT}>{t.notifSection}</div>
                <div style={s.profileCard}>
                  {[t.notif1,t.notif2,t.notif3,t.notif4].map((notif,i)=>(
                    <div key={i} style={i<3?s.toggleRow:{...s.toggleRow,borderBottom:"none"}}>
                      <span style={s.toggleLbl}>{notif}</span>
                      <div style={s.toggle}><div style={s.toggleThumb}/></div>
                    </div>
                  ))}
                </div>
              </div>

              {/* REFERRAL */}

              {/* IMAGES */}
              <div style={s.profileSection}>
                <div style={s.profileSecT}>{t.imgSection}</div>
                <div style={s.profileCard}>
                  <div style={{ padding:".5rem 0", borderBottom:`1px solid ${BORDER}` }}>
                    <div style={s.meterTop}>
                      <span style={s.profileLbl}>{user.imgUsed} {t.of} {user.imgTotal} {es?"usadas":"used"}</span>
                      <button style={s.profileLink} onClick={()=>setView("buy_imgs")}>{t.imgBuyMore}</button>
                    </div>
                    <div style={{ ...s.meterBar, marginTop:6 }}><div style={s.meterFill(imgPct,imgLow)}/></div>
                  </div>
                  <div style={s.profileRowLast}>
                    <span style={s.profileLbl}>{es?"Se renueva el":"Renews on"}</span>
                    <span style={s.profileVal}>{user.renewDate[lang]}</span>
                  </div>
                </div>
              </div>

              {/* SECURITY */}
              <div style={s.profileSection}>
                <div style={s.profileSecT}>{t.passSection}</div>
                <div style={s.profileCard}>
                  <div style={s.profileRowLast}>
                    <span style={s.profileLbl}>{user.email}</span>
                    <button style={s.profileLink} onClick={()=>{setShowPassChange(v=>!v); setPassMsg(null)}}>{t.passChange}</button>
                  </div>
                  {showPassChange && (
                    <div style={{ marginTop:12, display:"flex", flexDirection:"column", gap:8 }}>
                      <input type="password" placeholder={es?"Nueva contraseña":"New password"} value={newPass} onChange={e=>setNewPass(e.target.value)}
                        style={{ padding:"9px 12px", borderRadius:8, border:`1px solid ${V_MID}`, fontFamily:B, fontSize:13 }}/>
                      <input type="password" placeholder={es?"Repite la contraseña":"Repeat password"} value={newPass2} onChange={e=>setNewPass2(e.target.value)}
                        style={{ padding:"9px 12px", borderRadius:8, border:`1px solid ${V_MID}`, fontFamily:B, fontSize:13 }}/>
                      <button onClick={cambiarContrasena} disabled={savingPass}
                        style={{ padding:"9px 12px", borderRadius:8, border:"none", background:V, color:"#fff", fontFamily:B, fontSize:13, fontWeight:700, cursor:"pointer", opacity: savingPass?0.6:1 }}>
                        {savingPass ? (es?"Guardando...":"Saving...") : (es?"Guardar nueva contraseña":"Save new password")}
                      </button>
                      {passMsg && (
                        <div style={{ fontSize:12, fontFamily:B, color: passMsg.tipo==="ok" ? "#16A34A" : "#DC2626" }}>{passMsg.txt}</div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* DANGER */}
              <div style={s.profileSection}>
                <div style={s.profileSecT}>{t.dangerSection}</div>
                <div style={s.dangerCard}>
                  <div style={s.dangerT}>{t.deleteAccount}</div>
                  <div style={s.dangerD}>{t.deleteNote}</div>
                  <button style={s.dangerBtn}>{t.deleteAccount}</button>
                </div>
              </div>

            </div>
          </div>
        )}

      </div>

      {/* ── MODAL RE-ANALISIS ADN ── */}
      {reanalisisProyecto && (
        <div onClick={() => { if (reanalisisPaso !== 3) { setReanalisisProyecto(null); setReanalisisPaso(1); setReanalisisNuevaBio(""); setReanalisisResultado(null); setReanalisisError(null) } }} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "1rem" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: WHITE, borderRadius: 16, padding: "2rem", maxWidth: 520, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>

            {reanalisisPaso === 1 && (
              <div>
                <h2 style={{ fontSize: 20, fontWeight: 800, color: TEXT, fontFamily: H, marginBottom: ".75rem", letterSpacing: "-.01em" }}>{es ? "Re-analizar tu ADN" : "Re-analyze your DNA"}</h2>
                <p style={{ fontSize: 13, color: MUTED, fontFamily: B, marginBottom: "1.5rem", lineHeight: 1.5 }}>{es ? "Para que tu score se mueva, necesitas haber actualizado tu bio o cambiado como te presentas en tus redes/web." : "For your score to change, you need to have updated your bio or how you present yourself online."}</p>
                <p style={{ fontSize: 14, fontWeight: 700, color: TEXT, fontFamily: H, marginBottom: "1rem" }}>{es ? "¿Actualizaste tu bio?" : "Did you update your bio?"}</p>
                <div style={{ display: "flex", gap: ".75rem" }}>
                  <button style={{ flex: 1, padding: "12px", background: V, color: WHITE, border: "none", borderRadius: 10, fontFamily: H, fontSize: 13, fontWeight: 700, cursor: "pointer" }} onClick={() => setReanalisisPaso(2)}>{es ? "Si, la actualice" : "Yes, I updated it"}</button>
                  <button style={{ flex: 1, padding: "12px", background: WHITE, color: TEXT, border: `1px solid ${BORDER}`, borderRadius: 10, fontFamily: H, fontSize: 13, fontWeight: 700, cursor: "pointer" }} onClick={() => { setReanalisisProyecto(null); setReanalisisPaso(1) }}>{es ? "No, todavia no" : "No, not yet"}</button>
                </div>
                <p style={{ fontSize: 11, color: MUTED, fontFamily: B, marginTop: "1rem", fontStyle: "italic", lineHeight: 1.5 }}>{es ? "Tu negocio no cambio, pero tu comunicacion tampoco. Para que tu score suba, aplica lo que ya creamos contigo y vuelve cuando tengas cambios reales." : "Your business didn't change, neither did your communication. Apply what we built and come back with real changes."}</p>
              </div>
            )}

            {reanalisisPaso === 2 && (
              <div>
                <h2 style={{ fontSize: 20, fontWeight: 800, color: TEXT, fontFamily: H, marginBottom: ".75rem", letterSpacing: "-.01em" }}>{es ? "Pega tu nueva bio" : "Paste your new bio"}</h2>
                <p style={{ fontSize: 13, color: MUTED, fontFamily: B, marginBottom: "1rem", lineHeight: 1.5 }}>{es ? "Pega aqui tu nueva bio o ejemplo de como te presentas hoy en tus redes/web. KORIVA lo va a analizar." : "Paste your new bio or how you present yourself today. KORIVA will analyze it."}</p>
                <textarea
                  value={reanalisisNuevaBio}
                  onChange={(e) => setReanalisisNuevaBio(e.target.value.slice(0, 800))}
                  placeholder={es ? "Pega tu bio aqui..." : "Paste your bio here..."}
                  style={{ width: "100%", minHeight: 140, padding: "12px", border: `1px solid ${BORDER}`, borderRadius: 10, fontFamily: B, fontSize: 13, resize: "vertical", outline: "none", boxSizing: "border-box" }}
                />
                <div style={{ fontSize: 11, color: MUTED, fontFamily: B, marginTop: ".5rem", textAlign: "right" }}>{reanalisisNuevaBio.length}/800</div>
                <div style={{ display: "flex", gap: ".75rem", marginTop: "1.5rem" }}>
                  <button style={{ flex: 1, padding: "12px", background: WHITE, color: TEXT, border: `1px solid ${BORDER}`, borderRadius: 10, fontFamily: H, fontSize: 13, fontWeight: 700, cursor: "pointer" }} onClick={() => setReanalisisPaso(1)}>{es ? "Atras" : "Back"}</button>
                  <button
                    style={{ flex: 1, padding: "12px", background: reanalisisNuevaBio.trim().length < 20 ? "#ccc" : V, color: WHITE, border: "none", borderRadius: 10, fontFamily: H, fontSize: 13, fontWeight: 700, cursor: reanalisisNuevaBio.trim().length < 20 ? "not-allowed" : "pointer" }}
                    disabled={reanalisisNuevaBio.trim().length < 20}
                    onClick={async () => {
                      setReanalisisPaso(3)
                      setReanalisisError(null)
                      try {
                        const { data: { session } } = await supabase.auth.getSession()
                        const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:4000"
                        const res = await fetch(`${apiUrl}/api/analyze-ai-visibility`, {
                          method: "POST",
                          headers: { "Content-Type": "application/json", Authorization: `Bearer ${session.access_token}` },
                          body: JSON.stringify({ project_id: reanalisisProyecto, is_reanalysis: true, nueva_bio: reanalisisNuevaBio })
                        })
                        const data = await res.json()
                        if (!res.ok) { setReanalisisError(data.error || "Error"); setReanalisisPaso(2); return }
                        setReanalisisResultado(data)
                        setReanalisisPaso(4)
                        const { data: u } = await supabase.from("users").select("last_dna_reanalysis").eq("id", session.user.id).single()
                        if (u) setUser(prev => ({ ...prev, lastDnaReanalysis: u.last_dna_reanalysis }))
                        // Invalidar datos cargados del ADN para que se relean frescos de BD la proxima vez
                        setAdnDatos(null)
                      } catch (e) {
                        setReanalisisError(e.message)
                        setReanalisisPaso(2)
                      }
                    }}
                  >{es ? "Re-analizar" : "Re-analyze"}</button>
                </div>
                {reanalisisError && <p style={{ fontSize: 12, color: "#DC2626", fontFamily: B, marginTop: ".75rem" }}>{reanalisisError}</p>}
              </div>
            )}

            {reanalisisPaso === 3 && (
              <div style={{ textAlign: "center", padding: "2rem 0" }}>
                <div style={{ fontSize: 14, color: TEXT, fontFamily: B, marginBottom: ".5rem" }}>{es ? "Analizando tu nueva bio..." : "Analyzing your new bio..."}</div>
                <div style={{ fontSize: 11, color: MUTED, fontFamily: B }}>{es ? "Esto puede tardar unos segundos." : "This may take a few seconds."}</div>
              </div>
            )}

            {reanalisisPaso === 4 && reanalisisResultado && (
              <div>
                <h2 style={{ fontSize: 20, fontWeight: 800, color: TEXT, fontFamily: H, marginBottom: "1rem", letterSpacing: "-.01em" }}>{es ? "Tu progreso" : "Your progress"}</h2>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "1.5rem", padding: "1.5rem", background: V_SOFT, borderRadius: 12, marginBottom: "1.5rem" }}>
                  {reanalisisResultado.analisis_anterior && (
                    <div style={{ textAlign: "center" }}>
                      <div style={{ fontSize: 11, color: MUTED, fontFamily: B, marginBottom: ".25rem" }}>{es ? "Antes" : "Before"}</div>
                      <div style={{ fontSize: 36, fontWeight: 800, color: MUTED, fontFamily: H }}>{reanalisisResultado.analisis_anterior.score}</div>
                    </div>
                  )}
                  <div style={{ fontSize: 24, color: V }}>→</div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: 11, color: MUTED, fontFamily: B, marginBottom: ".25rem" }}>{es ? "Ahora" : "Now"}</div>
                    <div style={{ fontSize: 36, fontWeight: 800, color: V, fontFamily: H }}>{reanalisisResultado.score}</div>
                  </div>
                </div>
                {reanalisisResultado.resumen && <p style={{ fontSize: 13, color: TEXT, fontFamily: B, lineHeight: 1.5, marginBottom: "1rem", fontStyle: "italic" }}>"{reanalisisResultado.resumen}"</p>}
                <button style={{ width: "100%", padding: "12px", background: V, color: WHITE, border: "none", borderRadius: 10, fontFamily: H, fontSize: 13, fontWeight: 700, cursor: "pointer" }} onClick={() => { setReanalisisProyecto(null); setReanalisisPaso(1); setReanalisisNuevaBio(""); setReanalisisResultado(null); setReanalisisError(null); setAdnProyecto(reanalisisProyecto); setView("adn") }}>{es ? "Ver analisis completo" : "View full analysis"}</button>
              </div>
            )}

          </div>
        </div>
      )}

    </div>
  )
}

// ─────────────────────────────────────────────
// Componente: ADN de un proyecto (solo lectura)
// ─────────────────────────────────────────────
function AdnDetalle({ proyecto, datos, cargando, lang, onVolver }) {
  const es = lang === "es"
  const V = "#7C3AED", TEXT = "#18181B", MUTED = "#71717A", BORDER = "#E4E4E7", WHITE = "#FFFFFF"
  const V_SOFT = "#F5F3FF"
  const H = "'Plus Jakarta Sans', system-ui, sans-serif"
  const B = "'Manrope', system-ui, sans-serif"

  if (!proyecto) return null

  const vis = datos?.visibility
  const voz = datos?.voz
  const personas = datos?.personas || []
  const sug = vis?.sugerencias || {}
  const loClaro = Array.isArray(vis?.lo_claro) ? vis.lo_claro : []
  const loBorroso = Array.isArray(vis?.lo_borroso) ? vis.lo_borroso : []
  const versiones = Array.isArray(sug?.versiones_mejoradas) ? sug.versiones_mejoradas : []

  const card = { background:WHITE, border:`1px solid ${BORDER}`, borderRadius:14, padding:"1.3rem 1.4rem", marginBottom:"1.1rem" }
  const secLbl = { fontSize:11, fontWeight:700, letterSpacing:".1em", color:V, textTransform:"uppercase", fontFamily:B, marginBottom:".7rem" }
  const chip = { display:"inline-block", padding:"4px 10px", background:V_SOFT, color:V, borderRadius:20, fontSize:12, fontFamily:B, fontWeight:600, marginRight:6, marginBottom:6 }

  return (
    <div className="fi">
      <button onClick={onVolver}
        style={{ background:"none", border:"none", color:V, fontFamily:B, fontSize:13, fontWeight:700, cursor:"pointer", padding:0, marginBottom:"1rem", display:"flex", alignItems:"center", gap:6 }}>
        <span>←</span> <span>{es ? "Todos los proyectos" : "All projects"}</span>
      </button>

      <div style={{ fontSize:26, fontWeight:800, color:TEXT, fontFamily:H, letterSpacing:"-.02em", marginBottom:".2rem" }}>
        {es ? "ADN de " : "DNA of "}{proyecto.nombre[lang]||proyecto.nombre.es}
      </div>
      <div style={{ fontSize:13, color:MUTED, fontFamily:B, marginBottom:"1.5rem" }}>{proyecto.tipo[lang]||proyecto.tipo.es}</div>

      {cargando ? (
        <div style={{ padding:"3rem", textAlign:"center", color:MUTED, fontFamily:B }}>{es ? "Cargando ADN..." : "Loading DNA..."}</div>
      ) : (
      <>
        {/* AI VISIBILITY */}
        {vis ? (
          <div style={card}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:".7rem" }}>
              <div style={{ ...secLbl, marginBottom:0 }}>{es ? "Cómo te lee la Inteligencia Artificial" : "How Artificial Intelligence reads you"}</div>
              {vis.created_at && (
                <div style={{ fontSize:11, color:MUTED, fontFamily:B, fontWeight:500 }}>
                  {es ? "Analizado el " : "Analyzed on "}
                  {new Date(vis.created_at).toLocaleDateString(lang==="es"?"es-ES":"en-US", { day:"numeric", month:"long", year:"numeric" })}
                </div>
              )}
            </div>
            <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:"1rem" }}>
              <div style={{ width:76, height:76, borderRadius:"50%", background:V_SOFT, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                <span style={{ fontSize:30, fontWeight:800, color:V, fontFamily:H }}>{vis.score ?? "—"}</span>
              </div>
              <div>
                <div style={{ fontSize:16, fontWeight:700, color:TEXT, fontFamily:H }}>{es ? "Puntaje de claridad" : "Clarity score"}</div>
                <div style={{ fontSize:13, color:MUTED, fontFamily:B }}>{es ? "Qué tan claro comunica tu negocio hoy (sobre 100)." : "How clearly your business communicates today (out of 100)."}</div>
              </div>
            </div>
            {sug?.resumen && <div style={{ fontSize:15, color:TEXT, fontFamily:B, lineHeight:1.6, background:V_SOFT, padding:"14px 16px", borderRadius:10 }}>{sug.resumen}</div>}
          </div>
        ) : (
          <div style={card}><div style={{ fontSize:13, color:MUTED, fontFamily:B }}>{es ? "Este proyecto aún no tiene análisis de visibilidad." : "This project has no visibility analysis yet."}</div></div>
        )}

        {/* LO CLARO / LO BORROSO */}
        {(loClaro.length>0 || loBorroso.length>0) && (
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"1.1rem", marginBottom:"1.1rem" }}>
            <div style={{ ...card, marginBottom:0, borderTop:`3px solid #22C55E` }}>
              <div style={{ ...secLbl, color:"#16A34A" }}>{es ? "Lo que se entiende claro" : "What's clear"}</div>
              {loClaro.map((x,i)=>(<div key={i} style={{ fontSize:15, color:TEXT, fontFamily:B, lineHeight:1.6, marginBottom:10, display:"flex", gap:8 }}><span style={{color:"#16A34A"}}>✓</span><span>{x}</span></div>))}
            </div>
            <div style={{ ...card, marginBottom:0, borderTop:`3px solid #F59E0B` }}>
              <div style={{ ...secLbl, color:"#D97706" }}>{es ? "Lo que todavía está borroso" : "What's still blurry"}</div>
              {loBorroso.map((x,i)=>(<div key={i} style={{ fontSize:15, color:TEXT, fontFamily:B, lineHeight:1.6, marginBottom:10, display:"flex", gap:8 }}><span style={{color:"#D97706"}}>•</span><span>{x}</span></div>))}
            </div>
          </div>
        )}

        {/* VERSIONES MEJORADAS DE BIO */}
        {versiones.length>0 && (
          <div style={card}>
            <div style={secLbl}>{es ? "Te sugerimos estas BIOs para tu negocio" : "We suggest these BIOs for your business"}</div>
            {versiones.map((v,i)=>(
              <div key={i} style={{ fontSize:15, color:TEXT, fontFamily:B, lineHeight:1.6, padding:"14px 16px", background:"#FAFAFA", border:`1px solid ${BORDER}`, borderRadius:10, marginBottom:12 }}>{v}</div>
            ))}
          </div>
        )}

        {/* VOZ DE MARCA */}
        {voz && (
          <div style={card}>
            <div style={secLbl}>{es ? "Voz de marca generada por KORIVA" : "Brand voice generated by KORIVA"}</div>
            <div style={{ marginBottom:10 }}>
              {voz.tono && <span style={chip}>{es?"Tono: ":"Tone: "}{voz.tono}</span>}
              {voz.estilo && <span style={chip}>{es?"Estilo: ":"Style: "}{voz.estilo}</span>}
            </div>
            {voz.evitar && <div style={{ fontSize:15, color:TEXT, fontFamily:B, lineHeight:1.6, marginBottom:8 }}><strong>{es?"Evitar: ":"Avoid: "}</strong>{voz.evitar}</div>}
            {voz.ejemplo && <div style={{ fontSize:15, color:MUTED, fontFamily:B, fontStyle:"italic", lineHeight:1.6 }}>"{voz.ejemplo}"</div>}
          </div>
        )}

        {/* BUYER PERSONAS */}
        {personas.length>0 && (
          <div style={card}>
            <div style={secLbl}>{es ? "Conoce a tus clientes ideales" : "Meet your ideal customers"}</div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(240px, 1fr))", gap:"1rem" }}>
              {personas.map((p,i)=>(
                <div key={i} style={{ border:`1px solid ${BORDER}`, borderRadius:12, padding:"1rem 1.1rem" }}>
                  <div style={{ fontSize:20, fontWeight:800, color:TEXT, fontFamily:H, letterSpacing:"-.01em" }}>{p.nombre}</div>
                  <div style={{ fontSize:13, color:MUTED, fontFamily:B, marginBottom:10 }}>{[p.edad, p.ocupacion, p.ubicacion].filter(Boolean).join(" · ")}</div>
                  {p.descripcion && <div style={{ fontSize:14, color:TEXT, fontFamily:B, lineHeight:1.6, marginBottom:10 }}>{p.descripcion}</div>}
                  {p.necesidad && <div style={{ fontSize:14, fontFamily:B, lineHeight:1.6, marginBottom:7, color:TEXT }}><strong style={{color:V}}>{es?"Necesita: ":"Needs: "}</strong>{p.necesidad}</div>}
                  {p.que_valora && <div style={{ fontSize:14, fontFamily:B, lineHeight:1.6, marginBottom:7, color:TEXT }}><strong style={{color:V}}>{es?"Valora: ":"Values: "}</strong>{p.que_valora}</div>}
                  {p.como_decide && <div style={{ fontSize:14, fontFamily:B, lineHeight:1.6, marginBottom:7, color:TEXT }}><strong style={{color:V}}>{es?"Decide: ":"Decides: "}</strong>{p.como_decide}</div>}
                  {p.objecion && <div style={{ fontSize:14, fontFamily:B, lineHeight:1.6, color:TEXT }}><strong style={{color:V}}>{es?"Objeción: ":"Objection: "}</strong>{p.objecion}</div>}
                </div>
              ))}
            </div>
          </div>
        )}
      </>
      )}
    </div>
  )
}
